import React, { useContext, useEffect, useMemo, useState } from "react"
import { useDispatch, useSelector } from "react-redux"

import { getAmenities, getBrands, getCities, getDealDoneByUsers, getOEM, getStates } from "../../../Common/commonSlice"
import { getScopeWorkStatus } from "../../../Operations/OperationSlice"
import {
    addTicketPatch,
    addTicketPost,
    getFormStepDetail,
    getProjectsData,
    getProjectsTabs,
    resetRaiseTicketForm,
    selectSurveyId,
} from "../../ProjectSlice"
import { location_subtype_options, location_type_options } from "../../../../enums/dropdownValues"
import { FileInfo, submitFinalUploads, uploadFilesToS3 } from "../../../../utils/utils"
import { useUpdateProjectTicketChargersMutation } from "../../ProjectServices"
import { DropdownObj } from "../../../Common/commonTypes"
import { useUpsertSurveyTicketMutation } from "../../../Operations/features/Survey/SurveyService"

const initialBasicDetails = {
    project_name: "",
    project_closure_date: "",
    location_details_flag: { id: "", title: "" },
    charger_details: "",
    deal_done_by: { id: "", title: "" },
    deal_closure_date: "",
    client_poc_name: "",
    client_poc_contact: "",
    client_poc_email: "",
    pincode: "",
    cancelled_cheque: "",
    owner_company_relation_doc: "",
    agreement_doc: "",
    purchase_order: "",
    hosting_address: "",
    client_poc_state: { id: "", title: "" },
    client_poc_city: { id: "", title: "" },
    longitude: "",
    latitude: "",
    site_id: "",
    registration_address: "",
    registration_pincode: "",
    registration_state: { id: "", title: "" },
    registration_city: { id: "", title: "" },
    gstin: "",
    client_gst_certificate: "",
    edit_charger_file: "",
}

const FormContext: any = React.createContext(null)
const FormContextProvider = ({ children }: any) => {
    const {
        ops_ticket_id,
        projects_ticket_id,
        currentStepDetail,
        getFormStepDetailSuccess,
        getFormStepDetailLoading,
        addTicketPatchLoading,
        addTicketPatchSuccess,
        addTicketPostLoading,
        addTicketPostSuccess,
    } = useSelector((state: any) => state?.Projects)
    const { ProjectsFormValue, page, selectedValue } = useSelector((store: any) => store.Projects)
    const { ScopeStatusData } = useSelector((store: any) => store.operation)
    const { states, cities, dealDoneData, amenities = [] } = useSelector((state: any) => state.common)
    const { user_id } = useSelector((store: any) => store.verifyLogin)
    const { cpoList } = useSelector((store: any) => store.Projects)
    const [openModal, setOpenModal] = useState(false)
    const [step, setStep] = useState(1)
    const [allowedSteps, setAllowedSteps]: any = useState([])
    const [draftFlag, setDraftFlag] = useState(false)
    const [editFlag, setEditFlag] = useState(false)
    const [fromDraftFlag, setFromDraftFlag] = useState(false)
    const [editProjectId, setEditProjectId]: any = useState(null)
    const [editOpsId, setEditOpsId]: any = useState(null)
    const [registrationCityList, setRegistrationCityList] = useState<any>([])
    const [hostingCityList, setHostingCityList] = useState<any>([])
    const [selectedHostingAddress, setSelectedHostingAddress]: any = useState([])
    const [dealDetails, setDealDetails] = useState<any>({
        deal_type: "",
        deal_scope_of_work: [],
    })

    const [basicDetails, setBasicDetails]: any = useState(initialBasicDetails)
    const [amenitiesState, setAmenities] = useState([])
    const [buttonLoading, setButtonLoading] = useState(false)
    const [showError, setShowError] = useState(false)
    const [surveyTicketLinked, setSurveyTicketLinked] = useState(false)

    const [upsertSurveyTicket] = useUpsertSurveyTicketMutation()

    const [fileArr, setFileArr] = useState<FileInfo[]>([])

    const handleFileUpload = (fileList: FileInfo[]) => {
        let changedArr = [...fileArr]

        fileList.forEach(file => {
            if (!changedArr.some(i => i.doc_id === file.doc_id)) {
                changedArr.push(file)
            }
        })

        setFileArr(changedArr)
    }
    const [soloSurveyDetails, setsoloSurveyDetails]: any = useState({
        visit_by_date: "",
        visit_by_time: { id: "", title: "" },
        spot_image: "",
        electricity_bill: "",
        connection_type: { id: "", title: "" },
        survey_completion_date: "",
        demand_load: "",
        parking_slot: "",
        remarks: "",
        foundation_type: { id: "", title: "" },
        load_available: "",
        chargers: [],
    })
    const [siteDetails, setSiteDetails]: any = useState({
        siteType: {} as DropdownObj,
        siteName: "",
        siteAddress: "",
        pincode: "",
        country: { id: 101, title: "India" },
        state: null,
        city: null,
        latitude: "",
        longitude: "",
        search_site_name: "",
        search_pincode: "",
        siteId: null,
        selectedState: [],
        selectedCity: [],
        addedBy: [],
    })
    const [otherDetails, setOtherDetails]: any = useState({
        distributor_required: { id: 0, title: "No" },
        distributor_id: { id: "", title: "" },
        property_type: { id: "", title: "" },
        rent_agreement: "",
        access_type: { id: "", title: "" },
        trans_hpole_required: { id: "", title: "" },
        connection_type: { id: "", title: "" },
        dg_present: { id: "", title: "" },
        dg_unit_rate: "",
        survey_ticket_id: "",
        installation_flag: { id: "", title: "" },
        scope_of_work: { id: "", title: "" },
        sow_group_ids: [],
        is_ev_application_req: { id: "", title: "" },
        is_o_and_m_required: { id: "", title: "" },
        electricity_bill: "",
        evc_affidavit: "",
        per_unit_price: "",
        sanctioned_load: "",
        onboarding_flag: { id: "", title: "" },
        survey_id: { id: "", title: "" },
        ev_connection_owner: { id: "", title: "" },
        is_location_fixed: { id: "", title: "" },
        no_of_charger_spots: "",
        spot_image: "",
        fixed_electricity_charge: "",
        location_type: "",
        location_subtype: "",
    })
    const [onboardingDetails, setOnboardingDetails]: any = useState({
        onboarding_statiq: { id: "", title: "" },
        host_onboarding_flag: { id: "", title: "" },
        cpo_id: { id: "", title: "" },
        hosting_address: "",
        client_poc_state: { id: "", title: "" },
        client_poc_city: { id: "", title: "" },
        pincode: "",
    })

    const [cpoDetails, setCpoDetails] = useState({
        cpo_name: "",
        gstin: "",
        gst_address: "",
        email: "",
        operator_poc: "",
        phone_no: "",
        licence_cost_ac: "",
        licence_cost_dc: "",
        saas_fee: "",
        pincode: "",
        state_id: { id: "", title: "" },
        city_id: { id: "", title: "" },
        cpo_agreement: "",
        bank_details: "",
        cpo_id: "",
        poc_details: {
            name: "",
            phone_no: "",
            email: "",
        },
        admin_details: {
            name: "",
            phone_no: "",
            email: "",
        },
    })

    const [stationDetails, setStationDetails]: any = useState({
        name: "",
        area: "",
        state_id: { id: "", title: "" },
        city_id: { id: "", title: "" },
        pincode: "",
        accesss_type: { id: "", title: "" },
        landmark: "",
        latitude: "",
        longitude: "",
        is_open_24_hours: null,
        open_time: "",
        close_time: "",
        station_id: "",
    })

    const [hostDetails, setHostDetails]: any = useState({
        host_id: "",
        name: "",
        gstin: "",
        bank_details: "",
        gst_certificate: "",
        noc_host: "",
        kyc_document: "",
        admin_details: {
            id: "",
            name: "",
            phone_no: "",
            email: "",
        },
        poc_details: {
            id: "",
            name: "",
            phone_no: "",
            email: "",
        },
    })

    const [updateProjectTicketChargers] = useUpdateProjectTicketChargersMutation()

    useEffect(() => {
        setButtonLoading(addTicketPostLoading)
    }, [addTicketPostLoading])

    useEffect(() => {
        if (addTicketPatchSuccess) {
            if (step === 3) {
                //basic details to charger details
                if (projects_ticket_id || editProjectId) {
                    dispatch(getFormStepDetail({ page: 6, project_id: projects_ticket_id || editProjectId }))
                    resetFormData()
                }
            } else if (step === 4) {
                //charger details to other details
                dispatch(getFormStepDetail({ page: 2, project_id: projects_ticket_id || editProjectId }))
                resetFormData()
            } else if (isSaasOrLand() && step === 5) {
                //other details to onboarding details
                if (projects_ticket_id || editProjectId) {
                    dispatch(getFormStepDetail({ page: 4, project_id: projects_ticket_id || editProjectId }))
                    resetFormData()
                }
            } else if (!isSaasOrLand() && step === 5) {
                //other details to payment details
                if (projects_ticket_id || editProjectId) {
                    dispatch(getFormStepDetail({ page: 3, project_id: projects_ticket_id || editProjectId }))
                    resetFormData()
                }
            } else if (isSaasOrLand() && step === 6) {
                //onboarding details to payment details
                if (projects_ticket_id || editProjectId) {
                    dispatch(getFormStepDetail({ page: 3, project_id: projects_ticket_id || editProjectId }))
                    resetFormData()
                }
            } else if (!isSaasOrLand() && step === 6) {
                //payment details to spoc details
                if (otherDetails?.installation_flag?.id) {
                    if (projects_ticket_id || editProjectId) {
                        dispatch(getFormStepDetail({ page: 5, project_id: projects_ticket_id || editProjectId }))
                        resetFormData()
                    }
                }
            } else if (isSaasOrLand() && step === 7) {
                //payment details to spoc details
                if (otherDetails?.installation_flag?.id) {
                    if (projects_ticket_id || editProjectId) {
                        dispatch(getFormStepDetail({ page: 5, project_id: projects_ticket_id || editProjectId }))
                        resetFormData()
                    }
                }
            }
        }
    }, [addTicketPatchSuccess])

    const [charger_mapping, setChargerMapping]: any = useState([])
    const [hideAddChargerButton, setHideAddChargerButton] = useState(false)

    useEffect(() => {
        if (getFormStepDetailSuccess && (addTicketPostSuccess || addTicketPatchSuccess)) {
            if (!draftFlag) {
                setStep(prev => prev + 1)
                setFileArr([])
            }
        }

        setButtonLoading(getFormStepDetailLoading)
    }, [getFormStepDetailSuccess])

    const appendCpoId = (obj: any) => {
        setCpoDetails({ cpo_id: cpoDetails?.cpo_id, ...obj })
    }

    // Charger Details

    const chargerMappingSetter = (index: number, key: string, value: any) => {
        let clone: any = [...charger_mapping]
        clone[index] = { ...charger_mapping[index] }
        if (key === "charger_sku") {
            clone[index][key] = value?.title ?? null
            clone[index]["charger_type"] = value?.type ?? null
            clone[index]["charger_type_id"] = value?.id ?? null
        } else {
            clone[index][key] = value
        }
        setChargerMapping([...clone])
    }

    const addChargerMappingRow = () => {
        setHideAddChargerButton(true)
        let newRowData = { ...charger_mapping[0] }
        for (let key in newRowData) {
            newRowData[key] = ""
        }
        newRowData.charger_type_id = ""
        setChargerMapping((prev: any) => [...prev, newRowData])
    }

    const deleteChargerRow = (rowIndex: number) => {
        setChargerMapping((prev: any[]) => prev.filter((_, idx) => rowIndex !== idx))
        hideAddChargerButton && setHideAddChargerButton(false)
    }

    const getChargerMappingValue = (index: number, key: string) => {
        return charger_mapping?.[index]?.[key]
    }

    const handleChargerRowValidation = (rowIndex: number) => {
        let row = charger_mapping[rowIndex]
        if (
            !row?.branding_sku ||
            !row?.charger_sku ||
            !row?.is_sim_required?.title ||
            row?.warranty_duration == null ||
            row?.warranty_duration === "" ||
            row?.operational_power_rating == null ||
            row?.operational_power_rating === "" ||
            (dealDetails?.deal_type?.title !== "Outright" && !row?.charging_price) ||
            !row?.amc_purchased?.title ||
            !row?.insurance_required?.title ||
            !row?.amc_status
        ) {
            setShowError(true)
        } else {
            setHideAddChargerButton(false)
        }
    }

    const isChargerDetailsEditable = useMemo((): boolean => {
        const logisticsStatus = currentStepDetail.status_obj?.["Logistics"]?.name?.toLowerCase()

        if (!logisticsStatus) return true

        const editableStatuses = ["open", "dispatch initiated"]
        return editableStatuses.includes(logisticsStatus)
    }, [currentStepDetail])

    const [paymentDetails, setPaymentDetails]: any = useState({
        total_amount: "",
        specify_payment_terms: { id: "", title: "" },
        payment_terms: [],
    })

    const [paymentTerms, setPaymentTerms]: any = useState([
        {
            id: crypto.randomUUID(),
            pmt_type: { id: "", title: "" },
            pmt_percent: "",
            time_qty: "",
            time_uom: { id: 1, title: "Days" },
            condition: { id: "", title: "" },
            condition_text: "",
            bank_guarantee: false,
            pmt_due_date: "",
            payment_term_id: "",
            utr: "",
            original_amt: "",
            txn_due_date: "",
            paid_at: "",
            net_deduction: "",
            remarks: "",
            evidence_file: "",
        },
    ])
    const [surveyChargers, setSurveyChargers]: any = useState([
        {
            id: crypto.randomUUID(),
            charger_type: { id: "", title: "" },
            rating: "",
            quantity: "",
        },
    ])
    const addSurveyChargers = () => {
        const clone: any = [...surveyChargers]
        clone.push({
            id: new Date().getTime(),
            charger_type: { id: "", title: "" },
            rating: "",
            quantity: "",
        })

        setSurveyChargers([...clone])
        setsoloSurveyDetails({ ...soloSurveyDetails, chargers: [...clone] })
    }
    const removeSurveyChargers = (id: any) => {
        const clone: any = [...surveyChargers]
        const index = clone.findIndex((item: any) => item?.id === id)
        if (index > -1) {
            clone.splice(index, 1)
            setSurveyChargers([...clone])
            setsoloSurveyDetails({ ...soloSurveyDetails, chargers: [...clone] })
        }
    }

    const editSurveyChargers = (id: any, key: any, value: any) => {
        const clone: any = [...surveyChargers]
        const index = clone.findIndex((item: any) => item?.id === id)
        if (index > -1) {
            clone[index][key] = value
        }
        setSurveyChargers([...clone])
    }

    const getSurveyChargerValue = (id: any, key: any) => {
        const index = surveyChargers.findIndex((item: any) => item?.id === id)
        if (index > -1) {
            return surveyChargers[index][key]
        }
    }
    const isSaasOrLand = () => {
        return dealDetails?.deal_scope_of_work?.some((i: any) => i.id === 2 || i.id === 4)
    }

    const isOnlyCharger = () => {
        return dealDetails?.deal_scope_of_work?.length === 1 && dealDetails?.deal_scope_of_work?.some((i: any) => i.id === 1)
    }

    const paymentTermValidations = (paymentTerms: any) => {
        if (!(paymentTerms?.length >= 1)) {
            return true
        } else {
            for (let i = 0; i < paymentTerms?.length; i++) {
                if (paymentTerms?.reduce((acc: any, obj: any) => acc + parseFloat(obj.pmt_percent), 0) !== 100) {
                    return true
                }
                if (!paymentTerms?.[i]?.pmt_type?.title) {
                    return true
                }
                if (paymentTerms?.[i]?.pmt_type?.id === 1) {
                    if (!paymentTerms?.[i]?.condition?.title) {
                        return true
                    } else if (
                        paymentTerms?.[i]?.condition?.title === "other condition (please specify)" ||
                        paymentTerms?.[i]?.condition?.title === "Other conditions"
                    ) {
                        if (!paymentTerms?.[i]?.condition_text?.length) {
                            return true
                        }
                    } else if (paymentTerms?.[i]?.condition?.title === "Already paid as advance") {
                        if (
                            !paymentTerms?.[i]?.txn_due_date ||
                            !paymentTerms?.[i]?.original_amt ||
                            !paymentTerms?.[i]?.net_deduction ||
                            !paymentTerms?.[i]?.utr ||
                            !paymentTerms?.[i]?.paid_at ||
                            !paymentTerms?.[i]?.evidence_file
                        ) {
                            return true
                        }
                    } else if (!paymentTerms?.[i]?.time_uom?.title) {
                        return true
                    } else if (!paymentTerms?.[i]?.time_qty) {
                        return true
                    }
                }
                if (paymentTerms?.[i]?.pmt_type?.id === 0) {
                    if (!paymentTerms?.[i]?.pmt_due_date) {
                        return true
                    }
                }
                if (!paymentTerms?.[i]?.pmt_percent) {
                    return true
                }
            }
        }
    }

    const addPaymentTerms = () => {
        const clone: any = [...paymentTerms]
        clone.push({
            id: new Date().getTime(),
            pmt_type: { id: "", title: "" },
            pmt_percent: "",
            time_qty: "",
            time_uom: { id: 1, title: "Days" },
            condition: { id: "", title: "" },
            condition_text: "",
            bank_guarantee: "",
            pmt_due_date: "",
            payment_term_id: "",
            utr: "",
            original_amt: "",
            txn_due_date: "",
            paid_at: "",
            net_deduction: "",
        })

        setPaymentTerms([...clone])
        setPaymentDetails({ ...paymentDetails, payment_terms: [...clone] })
    }

    const removePaymentTerms = (id: any) => {
        const clone: any = [...paymentTerms]
        const index = clone.findIndex((item: any) => item?.id === id)
        if (index > -1) {
            clone.splice(index, 1)
            setPaymentTerms([...clone])
            setPaymentDetails({ ...paymentDetails, payment_terms: [...clone] })
        }
    }

    const editPaymentTerm = (id: any, key: any, value: any) => {
        const clone: any = [...paymentTerms]
        const index = clone.findIndex((item: any) => item?.id === id)
        if (index > -1) {
            clone[index][key] = value
        }
        setPaymentTerms([...clone])
    }

    const getPaymentTermsValue = (id: any, key: any) => {
        const index = paymentTerms.findIndex((item: any) => item?.id === id)
        if (index > -1) {
            return paymentTerms[index][key]
        }
    }

    const [spocDetails, setSpocDetails] = useState({
        name: "",
        contact_number: "",
        email: "",
    })

    const formSetter = (stepDetails: any, setStepDetails: any, key: any, value: any) => {
        const clone = { ...stepDetails }
        clone[key] = value
        setStepDetails({ ...clone })
    }

    const removeKey = (stepDetails: any, setStepDetails: any, key: any) => {
        const clone: any = { ...stepDetails }
        delete stepDetails[key]
        setStepDetails({ ...clone })
    }

    const handleSameAsClientPoc = () => {
        setSpocDetails(prev => ({
            ...prev,
            name: basicDetails?.client_poc_name,
            contact_number: basicDetails?.client_poc_contact,
            email: basicDetails?.client_poc_email,
        }))
    }

    const getValue = (stepDetails: any, key: any) => {
        return stepDetails?.[key]
    }
    const chargerMappingValidation = () => {
        if (charger_mapping?.length === 0) return true
        else {
            let flag = 0
            for (let i = 0; i < charger_mapping?.length; i++) {
                if (
                    charger_mapping[i]?.host_profit_amt === undefined ||
                    charger_mapping[i]?.host_profit_amt === null ||
                    charger_mapping[i]?.host_rent === undefined ||
                    charger_mapping[i]?.host_rent === null
                ) {
                    flag = 1
                    break
                }
            }
            if (flag) return true
        }
        return false
    }

    const chargerDetailsValidation = () => {
        if (!charger_mapping || charger_mapping.length === 0) return true
        const hasInvalidCharger = charger_mapping.some((charger: any) => {
            return (
                !charger?.branding_sku ||
                !charger?.charger_sku ||
                !charger?.is_sim_required?.title ||
                charger?.warranty_duration == null ||
                charger?.warranty_duration === "" ||
                charger?.operational_power_rating == null ||
                charger?.operational_power_rating === "" ||
                (dealDetails?.deal_type?.title !== "Outright" && !charger?.charging_price) ||
                !charger?.amc_purchased?.title ||
                !charger?.insurance_required?.title ||
                !charger?.amc_status
            )
        })

        return hasInvalidCharger
    }

    const validateLong = (value: any) => {
        return /^\d+\.\d{6,10}?$/.test(value) && parseFloat(value) >= -180 && parseFloat(value) <= 180
    }

    const validateLat = (value: any) => {
        return /^\d+\.\d{6,10}?$/.test(value) && parseFloat(value) >= -90 && parseFloat(value) <= 90
    }

    const disableSave = (stepName: string) => {
        switch (stepName) {
            case "DealDetails": {
                if (dealDetails?.deal_type && dealDetails?.deal_scope_of_work?.length) {
                    return false
                }
                return true
            }
            case "SiteDetails": {
                if (siteDetails?.siteId) {
                    return false
                }
                return true
            }
            case "BasicDetails": {
                if (
                    basicDetails?.project_name &&
                    basicDetails?.deal_closure_date &&
                    basicDetails?.location_details_flag &&
                    basicDetails?.deal_done_by &&
                    basicDetails?.project_closure_date &&
                    basicDetails?.client_poc_name &&
                    basicDetails?.client_poc_contact?.toString().length === 10 &&
                    (basicDetails?.client_poc_email ? isValidEmail(basicDetails?.client_poc_email) : true) &&
                    basicDetails?.charger_details &&
                    basicDetails?.registration_address &&
                    basicDetails?.registration_pincode &&
                    basicDetails?.registration_state?.title &&
                    basicDetails?.registration_city?.title &&
                    basicDetails?.gstin &&
                    (dealDetails?.deal_type?.title === "Outright" ||
                        (dealDetails?.deal_type?.title?.toLowerCase() === "cpo" &&
                            basicDetails?.agreement_doc &&
                            basicDetails?.client_gst_certificate))
                ) {
                    if (dealDetails?.deal_type?.title === "Outright" && !basicDetails?.purchase_order) {
                        return true
                    }
                    return false
                } else {
                    return true
                }
            }
            case "ChargerDetails": {
                return chargerDetailsValidation()
            }

            case "OtherDetails": {
                if (!otherDetails?.is_location_fixed?.title) {
                    return true
                } else if (otherDetails?.is_location_fixed?.title === "Yes" && !otherDetails?.no_of_charger_spots) {
                    return true
                }

                if (otherDetails?.installation_flag?.title) {
                    if (otherDetails?.installation_flag?.title === "Yes") {
                        if (!otherDetails?.access_type?.title) {
                            return true
                        }

                        if (
                            otherDetails?.fixed_electricity_charge === "" &&
                            dealDetails?.deal_scope_of_work?.some((i: any) => i.id === 3)
                        ) {
                            return true
                        }

                        if (otherDetails?.property_type?.title) {
                            if (otherDetails?.property_type?.title === "Rented") {
                                if (!otherDetails?.rent_agreement) {
                                    return true
                                }
                            }
                        } else {
                            return true
                        }

                        if (otherDetails?.scope_of_work?.title) {
                            if (otherDetails?.scope_of_work?.title?.toLowerCase() === "third party") {
                                if (!otherDetails?.sow_group_ids?.length) {
                                    return true
                                }
                            }
                        } else {
                            return true
                        }

                        if (otherDetails?.dg_present?.title) {
                            if (otherDetails?.dg_present?.title === "Yes") {
                                if (!otherDetails?.dg_unit_rate) {
                                    return true
                                }
                            }
                        } else {
                            return true
                        }

                        if (otherDetails?.is_ev_application_req?.title) {
                            if (otherDetails?.is_ev_application_req?.title === "Yes") {
                                if (
                                    !otherDetails?.evc_affidavit ||
                                    !otherDetails?.connection_type?.title ||
                                    !otherDetails?.ev_connection_owner?.title
                                ) {
                                    return true
                                }
                            }
                            if (
                                otherDetails?.is_ev_application_req?.title === "No" &&
                                !otherDetails?.electricity_bill
                            ) {
                                return true
                            }
                        } else {
                            return true
                        }
                    }
                }
                return false
            }

            case "PaymentDetails": {
                if (
                    !paymentDetails?.total_amount ||
                    !paymentDetails?.specify_payment_terms?.title ||
                    (paymentDetails?.specify_payment_terms?.title === "Yes" && paymentTermValidations(paymentTerms))
                ) {
                    return true
                }
                return false
            }

            case "OnboardingDetails": {
                if (
                    !stationDetails?.name ||
                    !stationDetails?.pincode ||
                    !stationDetails?.latitude ||
                    !stationDetails?.longitude ||
                    !stationDetails?.state_id?.title ||
                    !stationDetails?.city_id?.title ||
                    (dealDetails?.deal_scope_of_work?.some((i: any) => i.id === 2) &&
                        !onboardingDetails?.cpo_id?.id &&
                        !cpoDetails?.cpo_name) ||
                    !onboardingDetails?.onboarding_statiq?.title ||
                    !onboardingDetails?.host_onboarding_flag?.title ||
                    (onboardingDetails?.host_onboarding_flag?.id == 1 &&
                        (!hostDetails?.name ||
                            !onboardingDetails?.hosting_address ||
                            !onboardingDetails?.pincode ||
                            !(hostDetails?.gstin?.length === 15) ||
                            !hostDetails?.bank_details ||
                            !hostDetails?.gst_certificate ||
                            !hostDetails?.noc_host ||
                            !hostDetails?.kyc_document ||
                            !hostDetails?.admin_details?.name ||
                            !(hostDetails?.admin_details?.phone_no?.length === 10) ||
                            !isValidEmail(hostDetails?.admin_details?.email) ||
                            !hostDetails?.poc_details?.name ||
                            !(hostDetails?.poc_details?.phone_no?.length === 10) ||
                            !isValidEmail(hostDetails?.poc_details?.email) ||
                            chargerMappingValidation()))
                ) {
                    return true
                }
                return false
            }

            case "SpocDetails": {
                if (
                    spocDetails?.name &&
                    spocDetails?.contact_number?.toString()?.length === 10 &&
                    (spocDetails?.email ? isValidEmail(spocDetails?.email) : true)
                ) {
                    return false
                }
                return true
            }
        }
    }

    function isValidEmail(email: string) {
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/
        return emailRegex.test(email)
    }

    const onSubmit = async (edit: boolean, draft: boolean) => {
        let fileObj: Record<string, File[]> = {}
        let isCpo = dealDetails?.deal_type?.id === 0
        if (
            currentStepDetail?.survey_id &&
            step === 5 &&
            currentStepDetail?.survey_id !== otherDetails?.survey_id?.id
        ) {
            let surveyId = otherDetails?.survey_id?.id
            const res = await upsertSurveyTicket({
                project_id: currentStepDetail?.station?.project_id,
                old_survey_id: currentStepDetail?.survey_id,
                new_survey_id: surveyId || null,
            })
            if ((res as any)?.error) {
                await new Promise(resolve => setTimeout(resolve, 500))
            }
        } else if (surveyTicketLinked) {
            const formData = new FormData()
            formData.append("ops_ticket_id", currentStepDetail?.ops_ticket_id)
            formData.append("survey_id", otherDetails?.survey_id?.id)
            formData.append("user_id", user_id)
            dispatch(selectSurveyId(formData))
            setSurveyTicketLinked(false)
        }
        let filePayload = {
            ticket_id: currentStepDetail?.ops_ticket_id,
            file_infos: fileArr,
        }
        const formData = new FormData()
        setDraftFlag(draft)
        formData.append("user_id", user_id)
        if (currentStepDetail?.status_obj) {
            formData.append(
                "installation_status_id",
                currentStepDetail?.status_obj?.["Installation"]?.id
                    ? currentStepDetail?.status_obj?.["Installation"]?.id
                    : ""
            )
            formData.append(
                "project_status_id",
                currentStepDetail?.status_obj?.["Projects"]?.id ? currentStepDetail?.status_obj?.["Projects"]?.id : ""
            )
        }
        if (step === 3) {
            //BASIC DETAILS
            formData.append("page", "1")
            formData.append("project_name", basicDetails?.project_name)
            formData.append("project_closure_date", basicDetails?.project_closure_date)
            formData.append("deal_closure_date", basicDetails?.deal_closure_date)
            formData.append("hosting_address", siteDetails?.siteAddress)
            formData.append("state_id", siteDetails?.state?.id)
            formData.append("city_id", siteDetails?.city?.id)
            formData.append("latitude", siteDetails?.latitude)
            formData.append("longitude", siteDetails?.longitude)
            formData.append("pincode", siteDetails?.pincode)
            formData.append("site_id", siteDetails?.siteId)
            formData.append("deal_done_by_id", basicDetails?.deal_done_by?.id)
            formData.append("client_poc_name", basicDetails?.client_poc_name)
            formData.append("client_poc_contact", basicDetails?.client_poc_contact)
            formData.append("client_poc_email", basicDetails?.client_poc_email || "")
            formData.append("deal_type", dealDetails.deal_type.title)
            formData.append("deal_scope_of_work", JSON.stringify(dealDetails.deal_scope_of_work?.map((i: any) => i.id)))
            formData.append("registration_address", basicDetails?.registration_address)
            formData.append("registration_pincode", basicDetails?.registration_pincode)
            formData.append("registration_city_id", basicDetails?.registration_city?.id)
            formData.append("registration_state_id", basicDetails?.registration_state?.id)
            // formData.append("location_details_flag", siteDetails?.siteType?.id)
            formData.append("gstin", basicDetails?.gstin)
            if (!currentStepDetail?.ops_ticket_id) {
                if (typeof basicDetails?.cancelled_cheque === "object") {
                    fileObj["cancelled_cheque"] = Array.from(basicDetails?.cancelled_cheque)
                }
                if (typeof basicDetails?.owner_company_relation_doc === "object") {
                    fileObj["owner_company_relation_doc"] = Array.from(basicDetails?.owner_company_relation_doc)
                }
                if (typeof basicDetails?.agreement_doc === "object") {
                    fileObj["agreement_doc"] = Array.from(basicDetails?.agreement_doc)
                }
                if (typeof basicDetails?.purchase_order === "object") {
                    fileObj["purchase_order"] = Array.from(basicDetails?.purchase_order)
                }
                if (typeof basicDetails?.client_gst_certificate === "object") {
                    fileObj["client_gst_certificate"] = Array.from(basicDetails?.client_gst_certificate)
                }
            } else fileArr?.length && submitFinalUploads(filePayload)
            if (typeof basicDetails?.charger_details === "object") {
                formData.append("charger_details", basicDetails?.charger_details?.[0])
            }
            if (typeof basicDetails?.edit_charger_file === "object") {
                let fData = new FormData()
                fData.append("chargers_file", basicDetails?.edit_charger_file?.[0])
                fData.append("project_id", currentStepDetail?.station?.project_id)
                await updateProjectTicketChargers(fData)
            }
        } else if (step === 4) {
            //CHARGER DETAILS
            formData.append("page", "6")
            let charger_mapping_clone = charger_mapping?.map((object: any, index: number) => {
                return {
                    ...object,
                    host_profit_type: object?.host_profit_type?.id,
                    insurance_required: object?.insurance_required?.id,
                    amc_purchased: object?.amc_purchased?.id,
                    amc_status: object?.amc_purchased?.id === 1 ? (object?.amc_status?.id ?? null) : null,
                    is_sim_required: object?.is_sim_required?.id,
                    branding_id: object?.branding?.id,
                    branding_name: object?.branding?.name,
                    oem_id: object?.oem?.id,
                    oem_name: object?.oem?.name,
                }
            })
            delete charger_mapping_clone?.["branding"]
            delete charger_mapping_clone?.["oem"]
            formData.append("charger_mapping", JSON.stringify(charger_mapping_clone))
        } else if (step === 5) {
            //OTHER DETAILS
            formData.append("page", "2")
            formData.append("distributor_required", "0")
            formData.append("distributor_id", "")
            formData.append(
                "property_type",
                otherDetails?.installation_flag?.id ? otherDetails?.property_type?.title : ""
            )
            if (typeof otherDetails?.rent_agreement === "object") {
                formData.append(
                    "rent_agreement",
                    otherDetails?.installation_flag?.id && otherDetails?.property_type?.title === "Rented"
                        ? otherDetails?.rent_agreement?.[0]
                        : ""
                )
            }
            formData.append(
                "station_type",
                otherDetails?.installation_flag?.id ? otherDetails?.access_type?.title?.toLowerCase() : ""
            )
            formData.append("trans_hpole_required", isSaasOrLand() ? otherDetails?.trans_hpole_required?.id : "")
            formData.append(
                "connection_type",
                otherDetails?.installation_flag?.id ? otherDetails?.connection_type?.id : ""
            )
            formData.append(
                "ev_connection_owner",
                otherDetails?.installation_flag?.id && otherDetails?.is_ev_application_req?.id
                    ? otherDetails?.ev_connection_owner?.title?.toLowerCase() || ""
                    : ""
            )
            formData.append("dg_present", otherDetails?.installation_flag?.id ? otherDetails?.dg_present?.id : "")
            formData.append(
                "dg_unit_rate",
                otherDetails?.installation_flag?.id && otherDetails?.dg_present?.id ? otherDetails?.dg_unit_rate : ""
            )
            formData.append("installation_flag", otherDetails?.installation_flag?.id)
            formData.append(
                "scope_of_work",
                otherDetails?.installation_flag?.id ? otherDetails?.scope_of_work?.title : ""
            )
            formData.append(
                "sow_group_ids",
                otherDetails?.installation_flag?.id && otherDetails?.scope_of_work?.title === "Third Party"
                    ? JSON.stringify(
                          otherDetails?.sow_group_ids?.length
                              ? otherDetails?.sow_group_ids?.map((obj: any) => obj?.id)
                              : []
                      )
                    : JSON.stringify([])
            )
            formData.append(
                "is_ev_application_req",
                otherDetails?.installation_flag?.id ? otherDetails?.is_ev_application_req?.id : ""
            )
            formData.append("sanctioned_load", otherDetails?.sanctioned_load)
            formData.append(
                "is_o_and_m_required",
                otherDetails?.installation_flag?.id ? otherDetails?.is_o_and_m_required?.id : ""
            )

            formData.append("per_unit_price", otherDetails?.installation_flag?.id ? otherDetails?.per_unit_price : "")
            formData.append("onboarding_flag", isSaasOrLand() ? "1" : "0")
            formData.append("is_location_fixed", otherDetails?.is_location_fixed?.id)
            formData.append("no_of_charger_spots", otherDetails?.no_of_charger_spots)
            formData.append(
                "fixed_electricity_charge",
                otherDetails?.installation_flag?.id ? otherDetails?.fixed_electricity_charge : ""
            )
            fileArr?.length && submitFinalUploads(filePayload)
        } else if (isSaasOrLand() && step === 6) {
            //ONBOARDING DETAILS
            formData.append("page", "4")
            formData.append("onboarding_statiq", onboardingDetails?.onboarding_statiq?.id)
            formData.append("host_onboarding_flag", onboardingDetails?.host_onboarding_flag?.id)
            formData.append("cpo_id", onboardingDetails?.cpo_id?.id)
            formData.append("onboarding_flag", isSaasOrLand() ? "1" : "0")
            formData.append("site_id", currentStepDetail?.site_db_id)

            formData.append("hosting_address", onboardingDetails?.hosting_address)
            formData.append("state_id", onboardingDetails?.client_poc_state?.id)
            formData.append("city_id", onboardingDetails?.client_poc_city?.id)
            formData.append("pincode", onboardingDetails?.pincode)

            formData.append("location_type", otherDetails?.location_type?.title?.toLowerCase() || "")
            formData.append("location_subtype", otherDetails?.location_subtype?.title?.toLowerCase() || "")

            let charger_mapping_clone = charger_mapping?.map((object: any, index: number) => {
                return {
                    ...object,
                    host_profit_type: object?.host_profit_type?.id,
                    insurance_required: object?.insurance_required?.id,
                    amc_purchased: object?.amc_purchased?.id,
                    amc_status: object?.amc_purchased?.id === 1 ? object?.amc_status?.id : null,
                    branding_id: object?.branding?.id,
                    branding_name: object?.branding?.name,
                    oem_id: object?.oem?.id,
                    oem_name: object?.oem?.name,
                }
            })
            delete charger_mapping_clone?.["branding"]
            delete charger_mapping_clone?.["oem"]
            if (onboardingDetails?.host_onboarding_flag?.id == 1) {
                formData.append("charger_mapping", JSON.stringify(charger_mapping_clone))
            }
            if (!onboardingDetails?.cpo_id?.id) {
                formData.append("cpo", JSON.stringify(cpoDetails))
            }
            const stationDetailsObj = {
                station_id: stationDetails?.station_id,
                name: stationDetails?.name,
                area: stationDetails?.area,
                state_id: stationDetails?.state_id?.id,
                city_id: stationDetails?.city_id?.id,
                pincode: stationDetails?.pincode,
                accesss_type: stationDetails?.access_type?.id,
                landmark: stationDetails?.landmark,
                latitude: stationDetails?.latitude,
                longitude: stationDetails?.longitude,
                is_open_24_hours: stationDetails?.is_open_24_hours ? 1 : 0,
                open_time: stationDetails?.open_time?.length
                    ? stationDetails?.open_time
                          ?.split("")
                          ?.filter((item: any) => item !== ":")
                          ?.join("")
                    : "",
                close_time: stationDetails?.close_time?.length
                    ? stationDetails?.close_time
                          ?.split("")
                          ?.filter((item: any) => item !== ":")
                          ?.join("")
                    : "",
            }
            let amenitiesClone = [...amenitiesState]?.map((amenity: any) => {
                return { amenity_id: amenity?.["amenity_id"], amenity_name: amenity?.["amenity_name"] }
            })
            formData.append("amenities", JSON.stringify(amenitiesClone))
            formData.append("station", JSON.stringify(stationDetailsObj))
            let hostDetailsClone = { ...hostDetails }
            delete hostDetailsClone?.bank_details
            delete hostDetailsClone?.gst_certificate
            delete hostDetailsClone?.noc_host
            delete hostDetailsClone?.kyc_document
            if (onboardingDetails?.host_onboarding_flag?.id == 1) {
                formData.append("host", JSON.stringify(hostDetailsClone))
            }
            fileArr?.length && submitFinalUploads(filePayload)
        } else if (((!isSaasOrLand() && step === 6) || (isSaasOrLand() && step === 7)) && !isCpo) {
            //PAYMENT DETAILS
            const paymentTerms = paymentDetails?.specify_payment_terms?.id
                ? await Promise.all(
                      paymentDetails?.payment_terms?.map(async (term: any, idx: number) => {
                          if (term?.condition?.id === 7) {
                              if (typeof term?.evidence_file?.[0] !== "string") {
                                  formData.append(`evidence_file_${idx + 1}`, term?.evidence_file?.[0])
                              }
                          }
                          let payload: Record<string, any> = {
                              pmt_type: term?.pmt_type?.id,
                              pmt_percent: term?.pmt_percent,
                              bank_guarantee: term?.bank_guarantee || 0,
                              pmt_due_date: term?.pmt_due_date,
                              condition: term?.condition?.id,
                              time_qty: term?.time_qty,
                              time_uom: term?.time_uom?.id,
                              condition_text: term?.condition_text,
                              _id: idx + 1,
                          }

                          if (term?.payment_term_id) {
                              payload = {
                                  ...payload,
                                  payment_term_id: term?.payment_term_id,
                              }
                          }

                          let conditionalPayload: Record<string, any> = {
                              utr: term?.utr,
                              original_amt: term?.original_amt,
                              txn_due_date: term?.txn_due_date,
                              paid_at: term?.paid_at,
                              net_deduction: term?.net_deduction,
                              remarks: term?.remarks,
                          }

                          if (term?.transaction_id) {
                              conditionalPayload = {
                                  ...conditionalPayload,
                                  id: term?.transaction_id,
                              }
                          }

                          if (term?.condition?.id === 7 || term?.condition_text === "Already paid as advance") {
                              return {
                                  ...payload,
                                  payment_evidence: conditionalPayload,
                              }
                          }

                          return payload
                      })
                  )
                : null
            formData.append("page", "3")
            formData.append("total_amount", paymentDetails?.total_amount)
            formData.append("payment_terms_obj", paymentTerms ? JSON.stringify(paymentTerms) : "{}")
            formData.append("payment_terms", paymentDetails?.specify_payment_terms?.id)
            fileArr?.length && submitFinalUploads(filePayload)
        } else if (
            otherDetails?.installation_flag?.id &&
            ((!isSaasOrLand() && step === 7) ||
                (isSaasOrLand() && !isCpo && step === 8) ||
                (isSaasOrLand() && isCpo && step === 7) ||
                (!isSaasOrLand() && isCpo && step === 6)) || (isOnlyCharger() && step === 7)
        ) {
            //SPOC DETAILS
            if (draft) {
                formData.append("draft_flag", "1")
            }
            formData.append("page", "5")
            formData.append("spoc_name", spocDetails?.name)
            formData.append("spoc_phone", spocDetails?.contact_number)
            formData.append("spoc_email", spocDetails?.email ?? "")
            formData.append("installation_flag", otherDetails?.installation_flag?.id)
            formData.append("onboarding_flag", isSaasOrLand() ? "1" : "0")
        }
        if (editFlag && step !== 1 && step !== 2) {
            formData.append("project_id", editProjectId)
            formData.append("ops_ticket_id", editOpsId)
            let opsID = editOpsId
            let projectsID = editProjectId

            dispatch(addTicketPatch({ formData: formData })).then((res: any) => {
                if (
                    otherDetails?.installation_flag?.id === 0 &&
                    ((!isSaasOrLand() && step === 6) ||
                        (isSaasOrLand() && step === 7) ||
                        (isCpo && !isSaasOrLand() && step === 5) ||
                        (isCpo && isSaasOrLand() && step === 6))
                ) {
                    const formDataNew = new FormData()
                    formDataNew.append("user_id", user_id)
                    if (draft) {
                        formDataNew.append("draft_flag", "1")
                    }
                    formDataNew.append("page", "5")
                    formDataNew.append("project_id", projectsID)
                    formDataNew.append("ops_ticket_id", opsID)
                    formDataNew.append("installation_flag", otherDetails?.installation_flag?.id)
                    formDataNew.append("onboarding_flag", isSaasOrLand() ? "1" : "0")
                    if (currentStepDetail?.status_obj) {
                        formData.append(
                            "installation_status_id",
                            currentStepDetail?.status_obj?.["Installation"]?.id
                                ? currentStepDetail?.status_obj?.["Installation"]?.id
                                : ""
                        )
                        formData.append(
                            "project_status_id",
                            currentStepDetail?.status_obj?.["Projects"]?.id
                                ? currentStepDetail?.status_obj?.["Projects"]?.id
                                : ""
                        )
                    }
                    dispatch(addTicketPatch({ formData: formDataNew })).then(() => {
                        dispatch(getProjectsTabs({ data: ProjectsFormValue, page: page, selectedValue: selectedValue }))
                        dispatch(getProjectsData({ data: ProjectsFormValue, page: page, selectedValue: selectedValue }))
                    })
                } else if (
                    !addTicketPatchLoading &&
                    !draftFlag &&
                    ((isSaasOrLand() && otherDetails?.installation_flag?.title === "Yes" && step === 8) ||
                        (isSaasOrLand() && otherDetails?.installation_flag?.title === "No" && step === 7) ||
                        (!isSaasOrLand() && !isCpo && step === 7) ||
                        (!isSaasOrLand() && otherDetails?.installation_flag?.title === "No" && step === 5))
                ) {
                    dispatch(getProjectsTabs({ data: ProjectsFormValue, page: page, selectedValue: selectedValue }))
                    dispatch(getProjectsData({ data: ProjectsFormValue, page: page, selectedValue: selectedValue }))
                }
            })
        } else {
            if (step === 3 && !allowedSteps?.includes(4) && !editOpsId) {
                try {
                    const res = await dispatch(addTicketPost({ formData: formData }))
                    const decodedOpsId = res.payload[0]?.decoded_ops_id
                    const projectId = res.payload[0]?.project_id
                    setEditOpsId(decodedOpsId)
                    setEditProjectId(projectId)
                    if (decodedOpsId) {
                        await uploadFilesToS3(fileObj, decodedOpsId, true)
                        dispatch(getFormStepDetail({ page: 6, project_id: projectId }))
                    } else console.error("No Ops Id returned from the server")
                } catch (error) {
                    console.error("Error during file upload", error)
                }
            } else if (step !== 1 && step !== 2) {
                formData.append("project_id", projects_ticket_id)
                formData.append("ops_ticket_id", ops_ticket_id)
                let opsID = ops_ticket_id
                let projectsID = projects_ticket_id
                dispatch(addTicketPatch({ formData: formData })).then((res: any) => {
                    if (
                        otherDetails?.installation_flag?.id === 0 &&
                        ((!isSaasOrLand() && step === 6) ||
                            (isSaasOrLand() && step === 7) ||
                            (isCpo && !isSaasOrLand() && step === 5) ||
                            (isCpo && isSaasOrLand() && step === 6))
                    ) {
                        const formDataNew = new FormData()
                        formDataNew.append("user_id", user_id)
                        if (draft) {
                            formDataNew.append("draft_flag", "1")
                        }
                        formDataNew.append("page", "5")
                        formDataNew.append("project_id", projectsID)
                        formDataNew.append("ops_ticket_id", opsID)
                        formDataNew.append("installation_flag", otherDetails?.installation_flag?.id)
                        formDataNew.append("onboarding_flag", isSaasOrLand())
                        if (currentStepDetail?.status_obj) {
                            formData.append(
                                "installation_status_id",
                                currentStepDetail?.status_obj?.["Installation"]?.id
                                    ? currentStepDetail?.status_obj?.["Installation"]?.id
                                    : ""
                            )
                            formData.append(
                                "project_status_id",
                                currentStepDetail?.status_obj?.["Projects"]?.id
                                    ? currentStepDetail?.status_obj?.["Projects"]?.id
                                    : ""
                            )
                        }
                        dispatch(addTicketPatch({ formData: formDataNew })).then(() => {
                            dispatch(
                                getProjectsTabs({ data: ProjectsFormValue, page: page, selectedValue: selectedValue })
                            )
                            dispatch(
                                getProjectsData({ data: ProjectsFormValue, page: page, selectedValue: selectedValue })
                            )
                        })
                    } else if (
                        !addTicketPatchLoading &&
                        !draftFlag &&
                        ((isSaasOrLand() && otherDetails?.installation_flag?.title === "Yes" && step === 7) ||
                            (!isSaasOrLand() && step === 7) ||
                            (isSaasOrLand() && !isCpo && step === 8) ||
                            (!isSaasOrLand() &&
                                !isCpo &&
                                otherDetails?.installation_flag?.title === "Yes" &&
                                step === 7) ||
                            (!isSaasOrLand() && otherDetails?.installation_flag?.title === "No" && step === 5))
                    ) {
                        dispatch(getProjectsTabs({ data: ProjectsFormValue, page: page, selectedValue: selectedValue }))
                        dispatch(getProjectsData({ data: ProjectsFormValue, page: page, selectedValue: selectedValue }))
                    }
                })
            }
        }
    }

    const freezeField = (fieldName: string) => {
        const installationStatus = currentStepDetail?.status_obj?.["Installation"]?.name
        const applicationStatus = currentStepDetail?.status_obj?.["Ev application"]?.name
        const logisticsStatus = currentStepDetail?.status_obj?.["Logistics"]?.name
        const financeStatus = currentStepDetail?.status_obj?.["Finance"]?.name
        const stationStatus = currentStepDetail?.status_obj?.["Charging Stations"]?.name
        const hostStatus = currentStepDetail?.status_obj?.["Hosts"]?.name
        const cpoStatus = currentStepDetail?.status_obj?.["CPO"]?.name
        const projectsStatus = currentStepDetail?.status_obj?.["Projects"]?.name
        switch (fieldName) {
            //BASIC DETAILS
            case "project_name": {
                return false
            }

            case "project_closure_date": {
                if (
                    financeStatus === "Open" ||
                    financeStatus === "Approved" ||
                    financeStatus === "Verification In Progress" ||
                    financeStatus === "Paid In Full"
                ) {
                    return true
                }
                return false
            }

            case "location_details_flag": {
                if (
                    financeStatus === "Approved" ||
                    financeStatus === "Verification In Progress" ||
                    financeStatus === "Paid In Full"
                ) {
                    return true
                }
                return false
            }

            case "hosting_address": {
                if (
                    financeStatus === "Approved" ||
                    financeStatus === "Verification In Progress" ||
                    financeStatus === "Paid In Full"
                ) {
                    return true
                }
                return false
            }

            case "longitude": {
                if (
                    financeStatus === "Approved" ||
                    financeStatus === "Verification In Progress" ||
                    financeStatus === "Paid In Full"
                ) {
                    return true
                }
                return false
            }

            case "latitude": {
                if (
                    financeStatus === "Approved" ||
                    financeStatus === "Verification In Progress" ||
                    financeStatus === "Paid In Full"
                ) {
                    return true
                }
                return false
            }

            case "is_location_fixed": {
                if (
                    installationStatus === "Foundation Initiated" ||
                    installationStatus === "Foundation Done" ||
                    installationStatus === "Cabling Pending" ||
                    installationStatus === "Cabling Done" ||
                    installationStatus === "CP Installation Pending" ||
                    installationStatus === "CP Installation Initiated" ||
                    installationStatus === "CP Installation Done" ||
                    installationStatus === "Termination Pending" ||
                    installationStatus === "Termination Initiated" ||
                    installationStatus === "Termination Done" ||
                    installationStatus === "Commissioning Pending" ||
                    installationStatus === "Commissioning Initiated" ||
                    installationStatus === "Commissioning Done" ||
                    installationStatus === "Beautification Pending" ||
                    installationStatus === "Beautification Initiated" ||
                    installationStatus === "Beautification Done" ||
                    installationStatus === "Final Bill Pending" ||
                    installationStatus === "Completed" ||
                    installationStatus === "Deal Dropped" ||
                    installationStatus === "Blocked"
                ) {
                    return true
                }
                return false
            }

            case "no_of_charger_spots": {
                if (
                    installationStatus === "Foundation Initiated" ||
                    installationStatus === "Foundation Done" ||
                    installationStatus === "Cabling Pending" ||
                    installationStatus === "Cabling Done" ||
                    installationStatus === "CP Installation Pending" ||
                    installationStatus === "CP Installation Initiated" ||
                    installationStatus === "CP Installation Done" ||
                    installationStatus === "Termination Pending" ||
                    installationStatus === "Termination Initiated" ||
                    installationStatus === "Termination Done" ||
                    installationStatus === "Commissioning Pending" ||
                    installationStatus === "Commissioning Initiated" ||
                    installationStatus === "Commissioning Done" ||
                    installationStatus === "Beautification Pending" ||
                    installationStatus === "Beautification Initiated" ||
                    installationStatus === "Beautification Done" ||
                    installationStatus === "Final Bill Pending" ||
                    installationStatus === "Completed" ||
                    installationStatus === "Deal Dropped" ||
                    installationStatus === "Blocked"
                ) {
                    return true
                }
                return false
            }

            case "spot_image": {
                if (
                    installationStatus === "Foundation Initiated" ||
                    installationStatus === "Foundation Done" ||
                    installationStatus === "Cabling Pending" ||
                    installationStatus === "Cabling Done" ||
                    installationStatus === "CP Installation Pending" ||
                    installationStatus === "CP Installation Initiated" ||
                    installationStatus === "CP Installation Done" ||
                    installationStatus === "Termination Pending" ||
                    installationStatus === "Termination Initiated" ||
                    installationStatus === "Termination Done" ||
                    installationStatus === "Commissioning Pending" ||
                    installationStatus === "Commissioning Initiated" ||
                    installationStatus === "Commissioning Done" ||
                    installationStatus === "Beautification Pending" ||
                    installationStatus === "Beautification Initiated" ||
                    installationStatus === "Beautification Done" ||
                    installationStatus === "Final Bill Pending" ||
                    installationStatus === "Completed" ||
                    installationStatus === "Deal Dropped" ||
                    installationStatus === "Blocked"
                ) {
                    return true
                }
                return false
            }

            case "charger_details": {
                if (projectsStatus === "Open" || projectsStatus === "Completed" || projectsStatus === "In Progress") {
                    return true
                }
                return false
            }

            case "deal_done_by": {
                if (
                    financeStatus === "Open" ||
                    financeStatus === "Approved" ||
                    financeStatus === "Verification In Progress" ||
                    financeStatus === "Paid In Full"
                ) {
                    return true
                }
                return false
            }

            case "deal_closure_date": {
                if (
                    financeStatus === "Open" ||
                    financeStatus === "Approved" ||
                    financeStatus === "Verification In Progress" ||
                    financeStatus === "Paid In Full"
                ) {
                    return true
                }
                return false
            }

            case "client_poc_name": {
                return false
            }

            case "client_poc_contact": {
                return false
            }

            case "client_poc_state": {
                if (
                    financeStatus === "Approved" ||
                    financeStatus === "Verification In Progress" ||
                    financeStatus === "Paid In Full"
                ) {
                    return true
                }
                return false
            }

            case "client_poc_city": {
                if (
                    financeStatus === "Approved" ||
                    financeStatus === "Verification In Progress" ||
                    financeStatus === "Paid In Full"
                ) {
                    return true
                }
                return false
            }

            case "pincode": {
                if (
                    financeStatus === "Approved" ||
                    financeStatus === "Verification In Progress" ||
                    financeStatus === "Paid In Full"
                ) {
                    return true
                }
                return false
            }

            // case "site_id": {
            //   if (financeStatus === "Approved" || financeStatus === "Verification In Progress" || financeStatus === "Paid In Full") {
            //     return true;
            //   }
            //   return false
            // }

            case "cancelled_cheque": {
                if (
                    financeStatus === "Approved" ||
                    financeStatus === "Verification In Progress" ||
                    financeStatus === "Paid In Full"
                ) {
                    return true
                }
                return false
            }

            case "owner_company_relation_doc": {
                if (
                    financeStatus === "Approved" ||
                    financeStatus === "Verification In Progress" ||
                    financeStatus === "Paid In Full"
                ) {
                    return true
                }
                return false
            }

            case "agreement_doc": {
                if (
                    financeStatus === "Approved" ||
                    financeStatus === "Verification In Progress" ||
                    financeStatus === "Paid In Full"
                ) {
                    return true
                }
                return false
            }

            case "purchase_order": {
                if (
                    financeStatus === "Approved" ||
                    financeStatus === "Verification In Progress" ||
                    financeStatus === "Paid In Full" ||
                    dealDetails?.deal_type?.title?.toLowerCase() === "cpo"
                ) {
                    return true
                }
                return false
            }

            //CHARGER DETAILS
            case "branding": {
                if (logisticsStatus === "Dispatch Initiated" || logisticsStatus === "Dispatched") {
                    return true
                }
                return false
            }

            case "oem": {
                if (logisticsStatus === "Dispatch Initiated" || logisticsStatus === "Dispatched") {
                    return true
                }
                return false
            }

            case "charging_price": {
                if (
                    stationStatus === "Onboarding Initiated" ||
                    stationStatus === "Onboarded" ||
                    stationStatus === "Sanity" ||
                    stationStatus === "Go Live"
                ) {
                    return true
                }
                return false
            }

            //OTHER DETAILS

            case "property_type": {
                if (
                    installationStatus === "Foundation Initiated" ||
                    installationStatus === "Foundation Done" ||
                    installationStatus === "Cabling Pending" ||
                    installationStatus === "Cabling Done" ||
                    installationStatus === "CP Installation Pending" ||
                    installationStatus === "CP Installation Initiated" ||
                    installationStatus === "CP Installation Done" ||
                    installationStatus === "Termination Pending" ||
                    installationStatus === "Termination Initiated" ||
                    installationStatus === "Termination Done" ||
                    installationStatus === "Commissioning Pending" ||
                    installationStatus === "Commissioning Initiated" ||
                    installationStatus === "Commissioning Done" ||
                    installationStatus === "Beautification Pending" ||
                    installationStatus === "Beautification Initiated" ||
                    installationStatus === "Beautification Done" ||
                    installationStatus === "Final Bill Pending" ||
                    installationStatus === "Completed" ||
                    installationStatus === "Deal Dropped" ||
                    installationStatus === "Blocked" ||
                    stationStatus === "Onboarding Initiated" ||
                    stationStatus === "Onboarded" ||
                    stationStatus === "Sanity" ||
                    stationStatus === "Go Live"
                ) {
                    return true
                }
                return false
            }

            case "rent_agreement": {
                if (
                    installationStatus === "Foundation Initiated" ||
                    installationStatus === "Foundation Done" ||
                    installationStatus === "Cabling Pending" ||
                    installationStatus === "Cabling Done" ||
                    installationStatus === "CP Installation Pending" ||
                    installationStatus === "CP Installation Initiated" ||
                    installationStatus === "CP Installation Done" ||
                    installationStatus === "Termination Pending" ||
                    installationStatus === "Termination Initiated" ||
                    installationStatus === "Termination Done" ||
                    installationStatus === "Commissioning Pending" ||
                    installationStatus === "Commissioning Initiated" ||
                    installationStatus === "Commissioning Done" ||
                    installationStatus === "Beautification Pending" ||
                    installationStatus === "Beautification Initiated" ||
                    installationStatus === "Beautification Done" ||
                    installationStatus === "Final Bill Pending" ||
                    installationStatus === "Completed" ||
                    installationStatus === "Deal Dropped" ||
                    installationStatus === "Blocked" ||
                    stationStatus === "Onboarding Initiated" ||
                    stationStatus === "Onboarded" ||
                    stationStatus === "Sanity" ||
                    stationStatus === "Go Live"
                ) {
                    return true
                }
                return false
            }

            case "access_type": {
                if (
                    stationStatus === "Onboarding Initiated" ||
                    stationStatus === "Onboarded" ||
                    stationStatus === "Sanity" ||
                    stationStatus === "Go Live"
                ) {
                    return true
                }
                return false
            }

            case "trans_hpole_required": {
                if (applicationStatus) {
                    return true
                }
                return false
            }

            case "connection_type": {
                if (applicationStatus) {
                    return true
                }
                return false
            }

            case "dg_present": {
                if (applicationStatus) {
                    return true
                }
                return false
            }

            case "dg_unit_rate": {
                if (applicationStatus) {
                    return true
                }
                return false
            }

            case "survey_ticket_id": {
                if (
                    installationStatus === "Site Ready for Dispatch" ||
                    installationStatus === "Foundation Pending" ||
                    installationStatus === "Foundation Initiated" ||
                    installationStatus === "Foundation Done" ||
                    installationStatus === "Cabling Pending" ||
                    installationStatus === "Cabling Done" ||
                    installationStatus === "CP Installation Pending" ||
                    installationStatus === "CP Installation Initiated" ||
                    installationStatus === "CP Installation Done" ||
                    installationStatus === "Termination Pending" ||
                    installationStatus === "Termination Initiated" ||
                    installationStatus === "Termination Done" ||
                    installationStatus === "Commissioning Pending" ||
                    installationStatus === "Commissioning Initiated" ||
                    installationStatus === "Commissioning Done" ||
                    installationStatus === "Beautification Pending" ||
                    installationStatus === "Beautification Initiated" ||
                    installationStatus === "Beautification Done" ||
                    installationStatus === "Final Bill Pending" ||
                    installationStatus === "Completed" ||
                    installationStatus === "Deal Dropped" ||
                    installationStatus === "Blocked"
                ) {
                    return true
                }
                return false
            }

            case "installation_flag": {
                if (
                    installationStatus === "Foundation Initiated" ||
                    installationStatus === "Foundation Done" ||
                    installationStatus === "Cabling Pending" ||
                    installationStatus === "Cabling Done" ||
                    installationStatus === "CP Installation Pending" ||
                    installationStatus === "CP Installation Initiated" ||
                    installationStatus === "CP Installation Done" ||
                    installationStatus === "Termination Pending" ||
                    installationStatus === "Termination Initiated" ||
                    installationStatus === "Termination Done" ||
                    installationStatus === "Commissioning Pending" ||
                    installationStatus === "Commissioning Initiated" ||
                    installationStatus === "Commissioning Done" ||
                    installationStatus === "Beautification Pending" ||
                    installationStatus === "Beautification Initiated" ||
                    installationStatus === "Beautification Done" ||
                    installationStatus === "Final Bill Pending" ||
                    installationStatus === "Completed" ||
                    installationStatus === "Deal Dropped" ||
                    installationStatus === "Blocked"
                ) {
                    return true
                }
                return false
            }

            case "scope_of_work": {
                if (
                    installationStatus === "Foundation Initiated" ||
                    installationStatus === "Foundation Done" ||
                    installationStatus === "Cabling Pending" ||
                    installationStatus === "Cabling Done" ||
                    installationStatus === "CP Installation Pending" ||
                    installationStatus === "CP Installation Initiated" ||
                    installationStatus === "CP Installation Done" ||
                    installationStatus === "Termination Pending" ||
                    installationStatus === "Termination Initiated" ||
                    installationStatus === "Termination Done" ||
                    installationStatus === "Commissioning Pending" ||
                    installationStatus === "Commissioning Initiated" ||
                    installationStatus === "Commissioning Done" ||
                    installationStatus === "Beautification Pending" ||
                    installationStatus === "Beautification Initiated" ||
                    installationStatus === "Beautification Done" ||
                    installationStatus === "Final Bill Pending" ||
                    installationStatus === "Completed" ||
                    installationStatus === "Deal Dropped" ||
                    installationStatus === "Blocked"
                ) {
                    return true
                }
                return false
            }

            case "sow_group_ids": {
                return
            }

            case "is_ev_application_req": {
                if (applicationStatus) {
                    return true
                }
                return false
            }

            // case "is_o_and_m_required": {
            //   if (
            //     installationStatus === "Foundation Initiated" ||
            //     installationStatus === "Foundation Done" ||
            //     installationStatus === "Cabling Pending" ||
            //     installationStatus === "Cabling Done" ||
            //     installationStatus === "CP Installation Pending" ||
            //     installationStatus === "CP Installation Initiated" ||
            //     installationStatus === "CP Installation Done" ||
            //     installationStatus === "Termination Pending" ||
            //     installationStatus === "Termination Initiated" ||
            //     installationStatus === "Termination Done" ||
            //     installationStatus === "Commissioning Pending" ||
            //     installationStatus === "Commissioning Initiated" ||
            //     installationStatus === "Commissioning Done" ||
            //     installationStatus === "Beautification Pending" ||
            //     installationStatus === "Beautification Initiated" ||
            //     installationStatus === "Beautification Done" ||
            //     installationStatus === "Final Bill Pending" ||
            //     installationStatus === "Completed" ||
            //     installationStatus === "Deal Dropped" ||
            //     installationStatus === "Blocked"
            //   ) {
            //     return true;
            //   }
            //   return false;
            // }

            case "electricity_bill": {
                if (applicationStatus || getValue(otherDetails, "is_ev_application_req")?.title === "Yes") {
                    return true
                }
                return false
            }

            case "evc_affidavit": {
                if (applicationStatus || getValue(otherDetails, "is_ev_application_req")?.title === "No") {
                    return true
                }
                return false
            }

            case "per_unit_price": {
                if (applicationStatus || getValue(otherDetails, "is_ev_application_req")?.title === "Yes") {
                    return true
                }
                return false
            }

            case "sanctioned_load": {
                if (getValue(otherDetails, "is_ev_application_req")?.title === "Yes") {
                    return true
                }
                return false
            }

            case "onboarding_flag": {
                if (
                    stationStatus === "Onboarding Initiated" ||
                    stationStatus === "Onboarded" ||
                    stationStatus === "Sanity" ||
                    stationStatus === "Go Live"
                ) {
                    return true
                }
                return false
            }

            case "survey_id": {
                return
            }

            case "ev_connection_owner": {
                if (applicationStatus) {
                    return true
                }
                return false
            }

            //ONBOARDING DETAILS
            case "station_details": {
                if (
                    stationStatus === "Onboarding Initiated" ||
                    stationStatus === "Onboarded" ||
                    stationStatus === "Sanity" ||
                    stationStatus === "Go Live"
                ) {
                    return true
                }
                return false
            }

            case "host_details": {
                if (
                    hostStatus === "Onboarding Initiated" ||
                    hostStatus === "Onboarded" ||
                    !dealDetails?.deal_scope_of_work?.some(
                        (obj: { id: number; title: string }) => obj.id === 4 || obj.id === 2 // 1: Charger 2: SaaS 3: Infra 4: Land Deal 5: OEM
                    )
                ) {
                    return true
                }
                return false
            }

            case "cpo_details": {
                if (cpoStatus === "Onboarding Initiated" || cpoStatus === "Onboarded") {
                    return true
                }
                return false
            }

            //PAYMENT TERMS
            case "total_amount": {
                if (currentStepDetail?.drafts_flag === 0) {
                    if (
                        financeStatus === "Approved" ||
                        financeStatus === "Verification In Progress" ||
                        financeStatus === "Paid In Full"
                    ) {
                        return true
                    } else {
                        return false
                    }
                }
                return false
            }

            case "specify_payment_terms": {
                if (currentStepDetail?.drafts_flag === 0) {
                    if (
                        financeStatus === "Approved" ||
                        financeStatus === "Verification In Progress" ||
                        financeStatus === "Paid In Full"
                    ) {
                        return true
                    } else {
                        return false
                    }
                }
                return false
            }

            case "payment_terms": {
                if (currentStepDetail?.drafts_flag === 0) {
                    if (
                        financeStatus === "Approved" ||
                        financeStatus === "Verification In Progress" ||
                        financeStatus === "Paid In Full"
                    ) {
                        return true
                    } else {
                        return false
                    }
                }
                return false
            }

            //On Ground SPOC
            case "name": {
                return
            }

            case "contact_number": {
                return
            }

            default: {
                return false
            }
        }
    }

    const [maxStep, setMaxStep]: any = useState(null)
    useEffect(() => {
        setShowError(false)
        if (step > 1 && step > maxStep) {
            setMaxStep(step)
        }
        setDraftFlag(false)
    }, [step])

    useEffect(() => {
        if (maxStep > 1) {
            let allowedSteps = new Array(maxStep).fill("").map((_, index: number) => index + 1)
            setAllowedSteps(allowedSteps)
        }
    }, [maxStep])

    const dispatch = useDispatch()

    useEffect(() => {
        dispatch(getAmenities())
    }, [])

    useEffect(() => {
        setBasicDetails({
            ...basicDetails,
            client_poc_city: {
                id: currentStepDetail?.city_id,
                title: hostingCityList?.find((city: any) => city?.id == currentStepDetail?.city_id)?.name,
            },
        })
        setStationDetails({
            ...stationDetails,
            city_id: {
                id: currentStepDetail?.station?.city_id,
                title: cities?.find((city: any) => city?.id == currentStepDetail?.station?.city_id)?.name,
            },
        })
    }, [JSON.stringify(cities), JSON.stringify(hostingCityList)])

    useEffect(() => {
        if (basicDetails?.registration_state?.id && step === 3)
            dispatch(getCities(basicDetails?.registration_state?.id))
                .then((res: any) => {
                    setRegistrationCityList(res?.payload)
                })
                .catch((error: Error) => {
                    throw new Error(error?.message)
                })
    }, [JSON.stringify(basicDetails?.registration_state), step])

    const resetFormData = () => {
        setSelectedHostingAddress([])
        setRegistrationCityList([])
        setHostingCityList([])
        setBasicDetails(initialBasicDetails)
        setDealDetails({
            deal_type: "",
            deal_scope_of_work: [],
        })
        setHideAddChargerButton(false)

        setsoloSurveyDetails({
            visit_by_date: "",
            visit_by_time: { id: "", title: "" },
            spot_image: "",
            electricity_bill: "",
            connection_type: { id: "", title: "" },
            survey_completion_date: "",
            demand_load: "",
            parking_slot: "",
            remarks: "",
            foundation_type: { id: "", title: "" },
            load_available: "",
            chargers: [],
        })
        setSiteDetails({
            siteType: {} as DropdownObj,
            siteName: "",
            siteAddress: "",
            pincode: "",
            state: null,
            city: null,
            country: { id: 101, title: "India" },
            latitude: "",
            longitude: "",
            search_site_name: "",
            search_pincode: "",
            siteId: null,
            selectedState: [],
            selectedCity: [],
            addedBy: [],
        })
        setOtherDetails({
            distributor_required: { id: 0, title: "No" },
            distributor_id: { id: "", title: "" },
            property_type: { id: "", title: "" },
            rent_agreement: "",
            access_type: { id: "", title: "" },
            trans_hpole_required: { id: "", title: "" },
            connection_type: { id: "", title: "" },
            dg_present: { id: "", title: "" },
            dg_unit_rate: "",
            survey_ticket_id: "",
            installation_flag: { id: "", title: "" },
            scope_of_work: { id: "", title: "" },
            sow_group_ids: [],
            is_ev_application_req: { id: "", title: "" },
            is_o_and_m_required: { id: "", title: "" },
            electricity_bill: "",
            evc_affidavit: "",
            per_unit_price: "",
            sanctioned_load: "",
            onboarding_flag: { id: "", title: "" },
            survey_id: { id: "", title: "" },
            ev_connection_owner: { id: "", title: "" },
            is_location_fixed: { id: "", title: "" },
            no_of_charger_spots: "",
            spot_image: "",
            location_type: "",
            location_subtype: "",
        })

        setOnboardingDetails({
            onboarding_statiq: { id: "", title: "" },
            cpo_id: { id: "", title: "" },
            host_onboarding_flag: { id: "", title: "" },
        })

        setCpoDetails({
            cpo_name: "",
            gstin: "",
            gst_address: "",
            email: "",
            operator_poc: "",
            phone_no: "",
            licence_cost_ac: "",
            licence_cost_dc: "",
            saas_fee: "",
            pincode: "",
            state_id: { id: "", title: "" },
            city_id: { id: "", title: "" },
            cpo_agreement: "",
            bank_details: "",
            cpo_id: "",
            poc_details: {
                name: "",
                phone_no: "",
                email: "",
            },
            admin_details: {
                name: "",
                phone_no: "",
                email: "",
            },
        })

        setStationDetails({
            name: "",
            area: "",
            state_id: { id: "", title: "" },
            city_id: { id: "", title: "" },
            pincode: "",
            access_type: { id: "", title: "" },
            landmark: "",
            latitude: "",
            longitude: "",
            is_open_24_hours: null,
            open_time: "",
            close_time: "",
            station_id: "",
        })
        setAmenities([])

        setHostDetails({
            host_id: "",
            name: "",
            gstin: "",
            bank_details: "",
            gst_certificate: "",
            noc_host: "",
            kyc_document: "",
            admin_details: {
                id: "",
                name: "",
                phone_no: "",
                email: "",
            },
            poc_details: {
                id: "",
                name: "",
                phone_no: "",
                email: "",
            },
        })

        setChargerMapping([])

        setPaymentDetails({
            total_amount: "",
            specify_payment_terms: { id: "", title: "" },
            payment_terms: [],
        })

        setPaymentTerms([
            {
                id: new Date().getTime(),
                pmt_type: { id: "", title: "" },
                pmt_percent: "",
                time_qty: "",
                time_uom: { id: 1, title: "Days" },
                condition: { id: "", title: "" },
                condition_text: "",
                bank_guarantee: false,
                pmt_due_date: "",
                payment_term_id: "",
                utr: "",
                original_amt: "",
                txn_due_date: "",
                paid_at: "",
            },
        ])

        setSpocDetails({
            name: "",
            contact_number: "",
            email: "",
        })
        setSurveyTicketLinked(false)
    }

    useEffect(() => {
        if (openModal) {
            dispatch(getDealDoneByUsers())
            dispatch(getScopeWorkStatus())
            dispatch(getStates())
            dispatch(getOEM())
            dispatch(getBrands())
        }
        if (!openModal) {
            dispatch(resetRaiseTicketForm())
            setStep(1)
            setAllowedSteps([])
            setDraftFlag(false)
            resetFormData()
            setEditFlag(false)
            setFromDraftFlag(false)
            setEditProjectId(null)
            setEditOpsId(null)
            setMaxStep(null)
            setAmenities([])
            setShowError(false)
        }
    }, [openModal])

    function formatDate(inputDateStr: string) {
        const inputDate = new Date(inputDateStr)
        const year = inputDate.getFullYear()
        const month = String(inputDate.getMonth() + 1).padStart(2, "0") // Months are zero-based
        const day = String(inputDate.getDate()).padStart(2, "0")
        const formattedDate = `${year}-${month}-${day}`
        return formattedDate
    }
    const formatDateToInput = (dateStr: string) => {
        if (dateStr.includes("-")) {
            const [day, month, year] = dateStr.split("-")
            return `${year}-${month}-${day}` // '2025-04-18'
        } else {
            const formattedDate = new Date(dateStr).toISOString().split("T")[0]
            return formattedDate
        }
    }
    const getStepsArray = () => {
        let isCpo = dealDetails?.deal_type?.id === 0
        if (dealDetails?.deal_scope_of_work?.some((i: any) => i.id === 2 || i.id === 4)) {
            // 2 -> SaaS
            if (otherDetails?.installation_flag?.title === "Yes") {
                return [
                    "Deal Type",
                    "Location",
                    "Basic Details",
                    "Charger Details",
                    "Other Details",
                    "Onboarding Details",
                    !isCpo ? "Payment Details" : "",
                    "On-Ground POC Details",
                ]?.filter(Boolean)
            } else
                return [
                    "Deal Type",
                    "Location",
                    "Basic Details",
                    "Charger Details",
                    "Other Details",
                    "Onboarding Details",
                    !isCpo ? "Payment Details" : "",
                    "On-Ground POC Details",
                ]?.filter(Boolean)
        } else {
            if (otherDetails?.installation_flag?.title === "Yes")
                return [
                    "Deal Type",
                    "Location",
                    "Basic Details",
                    "Charger Details",
                    "Other Details",
                    !isCpo ? "Payment Details" : "",
                    "On-Ground POC Details",
                ]?.filter(Boolean)
            else {
                return [
                    "Deal Type",
                    "Location",
                    "Basic Details",
                    "Charger Details",
                    "Other Details",
                    !isCpo ? "Payment Details" : "",
                    "On-Ground POC Details",
                ]?.filter(Boolean)
            }
        }
    }

    useEffect(() => {
        if (currentStepDetail?.registration_city_id) {
            const city = registrationCityList?.find((city: any) => city?.id === currentStepDetail?.registration_city_id)
            if (!city) return
            setBasicDetails((prev: any) => ({
                ...prev,
                registration_city: {
                    id: currentStepDetail?.registration_city_id,
                    title: city?.name,
                },
            }))
        }
    }, [JSON.stringify(registrationCityList)])

    useEffect(() => {
        if (currentStepDetail?.city_id) {
            setBasicDetails((prev: any) => ({
                ...prev,
                client_poc_city: {
                    id: currentStepDetail?.city_id,
                    title: hostingCityList?.find((city: any) => city?.id == currentStepDetail?.city_id)?.name,
                },
            }))
        }
    }, [JSON.stringify(hostingCityList)])

    useEffect(() => {
        if (cpoList?.length) {
            setOnboardingDetails((prev: any) => ({
                ...prev,
                cpo_id: {
                    id:
                        dealDetails?.deal_type?.title?.toLowerCase() === "cpo"
                            ? cpoList?.find((cpo: any) => cpo?.name === "Statiq")?.id
                            : currentStepDetail?.cpo_id,
                    title:
                        dealDetails?.deal_type?.title?.toLowerCase() === "cpo"
                            ? "Statiq"
                            : cpoList?.find((cpo: any) => cpo?.id == currentStepDetail?.cpo_id)?.name ||
                              currentStepDetail?.cpo?.name,
                },
            }))
        }
    }, [JSON.stringify(cpoList), currentStepDetail])

    useEffect(() => {
        if (currentStepDetail?.name) {
            setBasicDetails({
                project_name: currentStepDetail?.name,
                project_closure_date: formatDate(currentStepDetail?.project_closure_date),
                location_details_flag: {
                    id: currentStepDetail?.location_details_flag,
                    title: currentStepDetail?.location_details_flag === 1 ? "New" : "Existing",
                },
                longitude: currentStepDetail?.longitude,
                latitude: currentStepDetail?.latitude,
                charger_details: currentStepDetail?.charger_details,
                deal_done_by: {
                    id: currentStepDetail?.deal_done_by_id,
                    title: dealDoneData?.find((data: any) => data?.id === currentStepDetail?.deal_done_by_id)?.name,
                },
                deal_closure_date: formatDate(currentStepDetail?.deal_closure_date),
                client_poc_name: currentStepDetail?.client_poc?.name,
                client_poc_contact: currentStepDetail?.client_poc?.phone,
                client_poc_email: currentStepDetail?.client_poc?.email,
                client_poc_city: {
                    id: currentStepDetail?.city_id,
                    title: hostingCityList?.find((city: any) => city?.id == currentStepDetail?.city_id)?.name,
                },
                pincode: currentStepDetail?.pincode,
                site_id: currentStepDetail?.site_db_id,
                cancelled_cheque: currentStepDetail?.cancelled_cheque,
                owner_company_relation_doc: currentStepDetail?.owner_company_relation_doc,
                agreement_doc: currentStepDetail?.agreement_doc,
                purchase_order: currentStepDetail?.purchase_order,
                registration_address: currentStepDetail?.registration_address,
                registration_pincode: currentStepDetail?.registration_pincode,
                registration_state: {
                    id: currentStepDetail?.registration_state_id,
                    title: states?.find((state: any) => state?.id == currentStepDetail?.registration_state_id)?.name,
                },
                registration_city: {
                    id: currentStepDetail?.registration_city_id,
                    title: registrationCityList?.find(
                        (city: any) => city?.id == currentStepDetail?.registration_city_id
                    )?.name,
                },
                gstin: currentStepDetail?.gstin,
                client_gst_certificate: currentStepDetail?.client_gst_certificate,
            })

            setSiteDetails({
                siteType: { id: 0, title: "Existing" },
                siteName: "",
                siteAddress: currentStepDetail?.hosting_address,
                pincode: currentStepDetail?.pincode,
                country: {
                    id: 101,
                    title: "India",
                },
                state: {
                    id: currentStepDetail?.state_id,
                    title: states?.find((state: any) => state?.id === currentStepDetail?.state_id)?.name,
                },
                city: {
                    id: currentStepDetail?.city_id,
                    title: "",
                },
                longitude: currentStepDetail?.longitude,
                latitude: currentStepDetail?.latitude,
                search_site_name: "",
                search_pincode: "",
                siteId: parseInt(currentStepDetail?.site_db_id),
                selectedState: [],
                selectedCity: [],
                addedBy: [],
            })

            setDealDetails({
                deal_type: {
                    id: currentStepDetail?.deal_type?.toLowerCase() === "cpo" ? 0 : 1,
                    title: currentStepDetail?.deal_type?.toLowerCase() === "cpo" ? "CPO" : currentStepDetail?.deal_type,
                },
                deal_scope_of_work: currentStepDetail?.deal_scope_of_work?.map((i: number) => {
                    let objMap: {
                        [key: number]: string
                    } = {
                        1: "Charger",
                        2: "SaaS",
                        3: "Infra",
                        4: "Land Deal",
                        5: "OEM",
                    }
                    return { id: i, title: objMap[i] }
                }),
            })

            if (currentStepDetail?.location_details_flag === 0) {
                setSelectedHostingAddress({
                    id: "",
                    title: currentStepDetail?.hosting_address,
                    hosting_address: currentStepDetail?.hosting_address,
                    site_id: currentStepDetail?.site_db_id,
                    latitude: currentStepDetail?.latitude,
                    longitude: currentStepDetail?.longitude,
                    pincode: currentStepDetail?.pincode,
                })
            }
            setOtherDetails({
                distributor_required: {
                    id: 0,
                    title: "No",
                },
                property_type: {
                    id: currentStepDetail?.property_type?.length
                        ? currentStepDetail?.property_type?.toLowerCase() === "owned/self"
                            ? "1"
                            : "0"
                        : "",
                    title: currentStepDetail?.property_type?.length
                        ? currentStepDetail?.property_type?.toLowerCase() === "owned/self"
                            ? "Owned/Self"
                            : "Rented"
                        : "",
                },
                rent_agreement: currentStepDetail?.rent_agreement,
                access_type: {
                    id: currentStepDetail?.station_type?.length
                        ? currentStepDetail?.station_type?.toLowerCase() === "public"
                            ? "0"
                            : "1"
                        : "",
                    title: currentStepDetail?.station_type?.length
                        ? currentStepDetail?.station_type?.toLowerCase() === "public"
                            ? "Public"
                            : "Captive"
                        : "",
                },
                trans_hpole_required: {
                    id: currentStepDetail?.trans_hpole_required,
                    title:
                        currentStepDetail?.trans_hpole_required === 1
                            ? "Yes"
                            : currentStepDetail?.trans_hpole_required === 0
                              ? "No"
                              : "",
                },
                connection_type: {
                    id: currentStepDetail?.connection_type,
                    title:
                        currentStepDetail?.connection_type == 1
                            ? "Commercial"
                            : currentStepDetail?.connection_type == 2
                              ? "Ev Connection"
                              : "",
                },
                dg_present: {
                    id: currentStepDetail?.dg_present,
                    title: currentStepDetail?.dg_present === 1 ? "Yes" : currentStepDetail?.dg_present == 0 ? "No" : "",
                },
                dg_unit_rate: currentStepDetail?.dg_unit_rate,
                survey_ticket_id: currentStepDetail?.survey_ticket_id,
                installation_flag: {
                    id: currentStepDetail?.deal_scope_of_work?.some((i: number) => i === 3)
                        ? 1
                        : currentStepDetail?.installation_flag,
                    title: currentStepDetail?.deal_scope_of_work?.some((i: number) => i === 3)
                        ? "Yes"
                        : currentStepDetail?.installation_flag === 1
                          ? "Yes"
                          : currentStepDetail?.installation_flag === 0
                            ? "No"
                            : "",
                },
                scope_of_work: {
                    id: currentStepDetail?.scope_of_work?.length
                        ? currentStepDetail?.scope_of_work?.toLowerCase() === "statiq"
                            ? 0
                            : 1
                        : "",
                    title: currentStepDetail?.scope_of_work?.length
                        ? currentStepDetail?.scope_of_work?.toLowerCase() === "statiq"
                            ? "Statiq"
                            : "Third Party"
                        : "",
                },
                sow_group_ids:
                    currentStepDetail?.sow_group_id?.length && Array.isArray(currentStepDetail?.sow_group_id)
                        ? currentStepDetail?.sow_group_id?.map((id: any, index: number) => {
                              let service = ScopeStatusData?.find((item: any) => item?.id == id)
                              if (service?.id) {
                                  return {
                                      id: service?.id,
                                      title: service?.name,
                                  }
                              }
                          })
                        : [],
                is_ev_application_req: {
                    id: currentStepDetail?.is_ev_application_req,
                    title:
                        currentStepDetail?.is_ev_application_req === 1
                            ? "Yes"
                            : currentStepDetail?.is_ev_application_req === 0
                              ? "No"
                              : "",
                },
                is_o_and_m_required: {
                    id: currentStepDetail?.is_o_and_m_required,
                    title:
                        currentStepDetail?.is_o_and_m_required === 1
                            ? "Yes"
                            : currentStepDetail?.is_o_and_m_required === 0
                              ? "No"
                              : "",
                },
                electricity_bill: currentStepDetail?.electricity_bill,
                evc_affidavit: currentStepDetail?.evc_affidavit,
                per_unit_price: currentStepDetail?.per_unit_price,
                onboarding_flag: {
                    id: currentStepDetail?.onboarding_flag,
                    title:
                        currentStepDetail?.onboarding_flag === 1
                            ? "Yes"
                            : currentStepDetail?.onboarding_flag === 0
                              ? "No"
                              : "",
                },
                survey_id: { id: currentStepDetail?.survey_id, title: currentStepDetail?.survey_name },
                ev_connection_owner: {
                    id:
                        currentStepDetail?.ev_connection_owner?.toLowerCase() === "host"
                            ? 0
                            : currentStepDetail?.ev_connection_owner?.toLowerCase() === "statiq"
                              ? 1
                              : currentStepDetail?.ev_connection_owner?.toLowerCase() === "third party"
                                ? 2
                                : "",
                    title:
                        currentStepDetail?.ev_connection_owner === "host"
                            ? "Host"
                            : currentStepDetail?.ev_connection_owner === "statiq"
                              ? "Statiq"
                              : currentStepDetail?.ev_connection_owner === "third party"
                                ? "Third Party"
                                : "",
                },
                is_location_fixed: {
                    id: currentStepDetail?.is_location_fixed,
                    title: currentStepDetail?.is_location_fixed === 1 ? "Yes" : "No",
                },
                no_of_charger_spots: currentStepDetail?.no_of_charger_spots,
                spot_image: currentStepDetail?.spot_image,
                sanctioned_load: currentStepDetail?.sanctioned_load,
                fixed_electricity_charge: currentStepDetail?.fixed_electricity_charge,
                location_type: location_type_options?.find(
                    opt => opt.title?.toLowerCase() === currentStepDetail?.station?.location_type?.toLowerCase()
                ),
                location_subtype: location_subtype_options?.find(
                    opt => opt.title?.toLowerCase() === currentStepDetail?.station?.location_subtype?.toLowerCase()
                ),
            })

            setOnboardingDetails({
                onboarding_statiq: {
                    id: currentStepDetail?.onboarding_statiq,
                    title:
                        currentStepDetail?.onboarding_statiq == 1
                            ? "Yes"
                            : currentStepDetail?.onboarding_statiq == 0
                              ? "No"
                              : "",
                },
                host_onboarding_flag: {
                    id: currentStepDetail?.host_onboarding_flag,
                    title:
                        currentStepDetail?.host_onboarding_flag === 1
                            ? "Yes"
                            : currentStepDetail?.host_onboarding_flag === 0
                              ? "No"
                              : "",
                },
                cpo_id: {
                    id:
                        dealDetails?.deal_type?.title?.toLowerCase() === "cpo"
                            ? cpoList?.find((cpo: any) => cpo?.name === "Statiq")?.id
                            : currentStepDetail?.cpo_id,
                    title:
                        dealDetails?.deal_type?.title?.toLowerCase() === "cpo"
                            ? cpoList?.find((cpo: any) => cpo?.name === "Statiq")?.name
                            : cpoList?.find((cpo: any) => cpo?.id == currentStepDetail?.cpo_id)?.name ||
                              currentStepDetail?.cpo?.name,
                },
                hosting_address: currentStepDetail?.hosting_address,
                client_poc_state: {
                    id: currentStepDetail?.state_id,
                    title: states?.find((state: any) => state?.id == currentStepDetail?.state_id)?.name,
                },
                pincode: currentStepDetail?.pincode,
                client_poc_city: { id: currentStepDetail?.city_id, title: "" },
            })

            setCpoDetails({
                cpo_name: currentStepDetail?.cpo?.cpo_name,
                gstin: currentStepDetail?.cpo?.gstin,
                gst_address: currentStepDetail?.cpo?.gst_address,
                email: currentStepDetail?.cpo?.email,
                operator_poc: currentStepDetail?.cpo?.operator_poc,
                phone_no: currentStepDetail?.cpo?.phone_no,
                licence_cost_ac: currentStepDetail?.cpo?.licence_cost_ac,
                licence_cost_dc: currentStepDetail?.cpo?.licence_cost_dc,
                saas_fee: currentStepDetail?.cpo?.saas_fee,
                cpo_id: currentStepDetail?.cpo?.cpo_id,
                pincode: currentStepDetail?.cpo?.pincode,
                state_id:
                    currentStepDetail?.cpo?.state_id !== null
                        ? {
                              id: currentStepDetail?.cpo?.state_id,
                              title: states?.find((state: any) => state?.id == currentStepDetail?.cpo?.state_id)?.name,
                          }
                        : {
                              id: currentStepDetail?.state_id,
                              title: states?.find((state: any) => state?.id == currentStepDetail?.state_id)?.name,
                          },
                city_id:
                    currentStepDetail?.cpo?.city_id !== null
                        ? {
                              id: currentStepDetail?.cpo?.city_id,
                              title: states?.find((state: any) => state?.id == currentStepDetail?.cpo?.city_id)?.name,
                          }
                        : {
                              id: currentStepDetail?.city_id,
                              title: cities?.find((state: any) => state?.id == currentStepDetail?.city_id)?.name,
                          },
                cpo_agreement: currentStepDetail?.cpo?.cpo_agreement,
                bank_details: currentStepDetail?.cpo?.cpo_bank_details,
                poc_details: {
                    name: "",
                    phone_no: "",
                    email: "",
                },
                admin_details: {
                    name: "",
                    phone_no: "",
                    email: "",
                },
            })

            setStationDetails({
                station_id: currentStepDetail?.station?.station_id,
                name: currentStepDetail?.station?.name,
                area: currentStepDetail?.station?.address || currentStepDetail?.hosting_address,
                state_id:
                    currentStepDetail?.station?.state_id !== null
                        ? {
                              id: currentStepDetail?.station?.state_id,
                              title: states?.find((state: any) => state?.id == currentStepDetail?.station?.state_id)
                                  ?.name,
                          }
                        : {
                              id: currentStepDetail?.state_id,
                              title: states?.find((state: any) => state?.id == currentStepDetail?.state_id)?.name,
                          },
                city_id:
                    currentStepDetail?.station?.city_id !== null
                        ? {
                              id: currentStepDetail?.station?.city_id,
                              title: cities?.find((city: any) => city?.id == currentStepDetail?.station?.city_id)?.name,
                          }
                        : {
                              id: currentStepDetail?.city_id,
                              title: cities?.find((city: any) => city?.id == currentStepDetail?.city_id)?.name,
                          },
                pincode:
                    currentStepDetail?.station?.pincode !== null
                        ? currentStepDetail?.station?.pincode
                        : currentStepDetail?.pincode,
                accesss_type: {
                    id: currentStepDetail?.station?.accesss_type?.length
                        ? currentStepDetail?.station?.accesss_type?.toLowerCase() === "public"
                            ? "0"
                            : "1"
                        : "",
                    title: currentStepDetail?.station?.accesss_type?.length
                        ? currentStepDetail?.station?.accesss_type?.toLowerCase() === "public"
                            ? "Public"
                            : "Captive"
                        : "",
                },
                landmark: currentStepDetail?.station?.landmark,
                latitude:
                    currentStepDetail?.station?.latitude !== null
                        ? currentStepDetail?.station?.latitude
                        : currentStepDetail?.latitude,
                longitude:
                    currentStepDetail?.station?.longitude !== null
                        ? currentStepDetail?.station?.longitude
                        : currentStepDetail?.longitude,
                is_open_24_hours: currentStepDetail?.station?.is_open_24_hours === 1,
                open_time: currentStepDetail?.station?.open_time
                    ? `${currentStepDetail?.station?.open_time?.toString()?.split("")[0]}${
                          currentStepDetail?.station?.open_time?.toString()?.split("")[1]
                      }:${currentStepDetail?.station?.open_time?.toString()?.split("")[2]}${
                          currentStepDetail?.station?.open_time?.toString()?.split("")[3]
                      }`
                    : "",
                close_time: currentStepDetail?.station?.close_time
                    ? `${currentStepDetail?.station?.close_time?.toString()?.split("")[0]}${
                          currentStepDetail?.station?.close_time?.toString()?.split("")[1]
                      }:${currentStepDetail?.station?.close_time?.toString()?.split("")[2]}${
                          currentStepDetail?.station?.close_time?.toString()?.split("")[3]
                      }`
                    : "",
            })
            const amenitiesClone: any = currentStepDetail?.amenities?.length ? [...currentStepDetail?.amenities] : []
            setAmenities(amenitiesClone)

            setHostDetails({
                host_id: currentStepDetail?.host?.host_id,
                name: currentStepDetail?.host?.name,
                gstin: currentStepDetail?.host?.gstin || currentStepDetail?.gstin,
                bank_details: currentStepDetail?.bank_details || currentStepDetail?.cancelled_cheque,
                gst_certificate: currentStepDetail?.gst_certificate || currentStepDetail?.client_gst_certificate,
                noc_host: currentStepDetail?.noc_host,
                kyc_document: currentStepDetail?.kyc_document,
                admin_details: {
                    id: currentStepDetail?.host?.admin_details?.id,
                    name: currentStepDetail?.host?.admin_details?.name,
                    phone_no: currentStepDetail?.host?.admin_details?.phone_no,
                    email: currentStepDetail?.host?.admin_details?.email,
                },
                poc_details: {
                    id: currentStepDetail?.host?.poc_details?.id,
                    name: currentStepDetail?.host?.poc_details?.name,
                    phone_no: currentStepDetail?.host?.poc_details?.phone_no,
                    email: currentStepDetail?.host?.poc_details?.email,
                },
            })
            let mappingClone = currentStepDetail?.charger_mapping?.map((object: any, index: number) => {
                return {
                    ...object,
                    host_profit_type:
                        object?.host_profit_type === 1
                            ? { id: 1, title: "₹" }
                            : object?.host_profit_type === 0
                              ? { id: 0, title: "%" }
                              : null,
                    insurance_required:
                        object?.insurance_required === 1
                            ? { id: 1, title: "Yes" }
                            : object?.insurance_required === 0
                              ? { id: 0, title: "No" }
                              : null,
                    amc_purchased:
                        object?.amc_purchased === 1
                            ? { id: 1, title: "Yes" }
                            : object?.amc_purchased === 0
                              ? { id: 0, title: "No" }
                              : null,
                    amc_status: object?.amc_purchased
                        ? object?.amc_status === 1
                            ? { id: 1, title: "Active" }
                            : object?.amc_status === 0
                              ? { id: 0, title: "Expired" }
                              : { id: -1, title: "Inactive" }
                        : { id: null, title: "-" },
                    branding: { id: object?.branding_id, title: object?.branding_name },
                    oem: { id: object?.oem_id, title: object?.oem_name },
                    is_sim_required:
                        object?.is_sim_required === 1
                            ? { id: 1, title: "Yes" }
                            : object?.is_sim_required === 0
                              ? { id: 0, title: "No" }
                              : null,
                }
            })
            setChargerMapping(mappingClone?.length ? [...mappingClone] : [])

            const paymentTermsTemp = currentStepDetail?.payment_terms_obj?.map((term: any) => {
                return {
                    id: crypto?.randomUUID(),
                    transaction_id: term?.transactions?.[0]?.id,
                    pmt_type: {
                        id: term?.pmt_type,
                        title: term?.pmt_type === 1 ? "Set conditional time frame" : "Set custom date",
                    },
                    pmt_percent: term?.pmt_percent,
                    time_qty: term?.time_qty,
                    time_uom: [
                        { id: 1, title: "Days" },
                        { id: 2, title: "Weeks" },
                        { id: 3, title: "Months" },
                    ].find((item: any) => item?.id === term?.time_uom),
                    condition: {
                        id: term.condition_id,
                        title: term.condition_text,
                    },
                    condition_text: term?.condition_text,
                    bank_guarantee: term?.bank_guarantee,
                    pmt_due_date: term?.pmt_due_date ? formatDateToInput(term?.pmt_due_date) : "",
                    payment_term_id: term?.id,
                    utr: term?.transactions?.[0]?.utr,
                    original_amt: term?.transactions?.[0]?.original_amt,
                    txn_due_date: term?.transactions?.[0]?.txn_due_date
                        ? formatDateToInput(term?.transactions?.[0]?.txn_due_date)
                        : "",
                    paid_at: term?.transactions?.[0]?.paid_at
                        ? formatDateToInput(term?.transactions?.[0]?.paid_at)
                        : "",
                    net_deduction: term?.transactions?.[0]?.net_deduction,
                    remarks: term?.transactions?.[0]?.remarks,
                    evidence_file: term?.transactions?.[0]?.file_url?.urls?.view
                        ? [term?.transactions?.[0]?.file_url?.urls?.view]
                        : null,
                }
            })

            setPaymentDetails({
                total_amount:
                    currentStepDetail?.total_amount !== null || currentStepDetail?.total_amount !== undefined
                        ? JSON.stringify(currentStepDetail?.total_amount)
                        : "",
                specify_payment_terms: {
                    id: currentStepDetail?.payment_terms,
                    title:
                        currentStepDetail?.payment_terms === 1
                            ? "Yes"
                            : currentStepDetail?.payment_terms === 0
                              ? "No"
                              : "",
                },
            })

            setPaymentTerms(paymentTermsTemp || [])

            setSpocDetails({
                name: currentStepDetail?.on_ground_poc?.name,
                contact_number: currentStepDetail?.on_ground_poc?.phone,
                email: currentStepDetail?.on_ground_poc?.email,
            })

            setMaxStep(null)
        }
    }, [currentStepDetail])

    return (
        <FormContext.Provider
            value={{
                dispatch,
                chargerMappingValidation,
                buttonLoading,
                editProjectId,
                hideAddChargerButton,
                handleChargerRowValidation,
                isChargerDetailsEditable,
                setEditProjectId,
                editOpsId,
                setEditOpsId,
                appendCpoId,
                handleFileUpload,
                getFormStepDetailLoading,
                selectedHostingAddress,
                setSelectedHostingAddress,
                step,
                setStep,
                allowedSteps,
                onSubmit,
                basicDetails,
                handleSameAsClientPoc,
                setBasicDetails,
                otherDetails,
                setOtherDetails,
                siteDetails,
                setSiteDetails,
                setsoloSurveyDetails,
                onboardingDetails,
                setOnboardingDetails,
                cpoDetails,
                setCpoDetails,
                stationDetails,
                setStationDetails,
                hostDetails,
                setHostDetails,
                paymentDetails,
                setPaymentDetails,
                surveyChargers,
                setSurveyChargers,
                getSurveyChargerValue,
                addSurveyChargers,
                removeSurveyChargers,
                editSurveyChargers,
                spocDetails,
                setSpocDetails,
                formSetter,
                getValue,
                removeKey,
                paymentTerms,
                addPaymentTerms,
                editPaymentTerm,
                removePaymentTerms,
                getPaymentTermsValue,
                disableSave,
                openModal,
                setOpenModal,
                editFlag,
                setEditFlag,
                fromDraftFlag,
                setFromDraftFlag,
                chargerMappingSetter,
                deleteChargerRow,
                addChargerMappingRow,
                getChargerMappingValue,
                charger_mapping,
                amenities,
                setAmenities,
                amenitiesState,
                showError,
                setShowError,
                isValidEmail,
                validateLong,
                validateLat,
                ops_ticket_id,
                getStepsArray,
                freezeField,
                surveyTicketLinked,
                setSurveyTicketLinked,
                currentStepDetail,
                dealDetails,
                setDealDetails,
                registrationCityList,
                hostingCityList,
            }}>
            {children}
        </FormContext.Provider>
    )
}

export const useFormContext = () => {
    const {
        dispatch,
        chargerMappingValidation,
        buttonLoading,
        editProjectId,
        handleFileUpload,
        hideAddChargerButton,
        handleChargerRowValidation,
        isChargerDetailsEditable,
        setEditProjectId,
        editOpsId,
        setEditOpsId,
        selectedHostingAddress,
        appendCpoId,
        getFormStepDetailLoading,
        setSelectedHostingAddress,
        step,
        setStep,
        allowedSteps,
        onSubmit,
        basicDetails,
        handleSameAsClientPoc,
        setBasicDetails,
        otherDetails,
        soloSurveyDetails,
        setOtherDetails,
        setSiteDetails,
        siteDetails,
        setsoloSurveyDetails,
        onboardingDetails,
        setOnboardingDetails,
        cpoDetails,
        setCpoDetails,
        stationDetails,
        setStationDetails,
        hostDetails,
        setHostDetails,
        paymentDetails,
        setPaymentDetails,
        surveyChargers,
        setSurveyChargers,
        addSurveyChargers,
        removeSurveyChargers,
        editSurveyChargers,
        getSurveyChargerValue,
        spocDetails,
        setSpocDetails,
        formSetter,
        getValue,
        removeKey,
        paymentTerms,
        addPaymentTerms,
        editPaymentTerm,
        removePaymentTerms,
        getPaymentTermsValue,
        disableSave,
        openModal,
        setOpenModal,
        editFlag,
        setEditFlag,
        fromDraftFlag,
        setFromDraftFlag,
        chargerMappingSetter,
        deleteChargerRow,
        addChargerMappingRow,
        getChargerMappingValue,
        charger_mapping,
        amenities,
        setAmenities,
        amenitiesState,
        showError,
        setShowError,
        validateLong,
        validateLat,
        isValidEmail,
        ops_ticket_id,
        getStepsArray,
        freezeField,
        surveyTicketLinked,
        setSurveyTicketLinked,
        currentStepDetail,
        dealDetails,
        setDealDetails,
        registrationCityList,
        hostingCityList,
    }: any = useContext(FormContext)
    return {
        dispatch,
        handleFileUpload,
        editProjectId,
        setEditProjectId,
        editOpsId,
        setEditOpsId,
        selectedHostingAddress,
        setSelectedHostingAddress,
        step,
        setStep,
        onSubmit,
        allowedSteps,
        dealDetails,
        openModal,
        setOpenModal,
        editFlag,
        setEditFlag,
        fromDraftFlag,
        setFromDraftFlag,
        currentStepDetail,
        dealDetailsSetter: (key: string, value: string | DropdownObj[]) => {
            formSetter(dealDetails, setDealDetails, key, value)
        },
        getDealDetailsValue: (key: string) => getValue(dealDetails, key),

        basicDetailsSetter: (key: any, value: any) => {
            formSetter(basicDetails, setBasicDetails, key, value)
        },
        getBasicDetailsValue: (key: any) => getValue(basicDetails, key),
        removeBasicDetailsKey: (key: any) => {
            removeKey(basicDetails, setBasicDetails, key)
        },

        otherDetailsSetter: (key: any, value: any) => {
            formSetter(otherDetails, setOtherDetails, key, value)
        },
        getOtherDetailsValue: (key: any) => getValue(otherDetails, key),
        removeOtherDetailsKey: (key: any) => {
            removeKey(otherDetails, setOtherDetails, key)
        },

        siteDetailsSetter: (key: any, value: any) => {
            formSetter(siteDetails, setSiteDetails, key, value)
        },
        getSiteDetailsValue: (key: any) => getValue(siteDetails, key),
        removeSiteDetailsKey: (key: any) => {
            removeKey(siteDetails, setSiteDetails, key)
        },

        soloSurveyDetailsSetter: (key: any, value: any) => {
            formSetter(soloSurveyDetails, setsoloSurveyDetails, key, value)
        },
        getSurveyValue: (key: any) => getValue(soloSurveyDetails, key),
        removeSoloSurveyDetailsKey: (key: any) => {
            removeKey(soloSurveyDetails, setsoloSurveyDetails, key)
        },
        surveyChargers,
        setSurveyChargers,
        addSurveyChargers,
        editSurveyChargers,
        removeSurveyChargers,
        getSurveyChargerValue,

        onboardingDetailsSetter: (key: any, value: any) => {
            formSetter(onboardingDetails, setOnboardingDetails, key, value)
        },
        getOnboardingDetailsValue: (key: any) => getValue(onboardingDetails, key),
        removeOnboardingDetailsKey: (key: any) => {
            removeKey(onboardingDetails, setOnboardingDetails, key)
        },

        appendCpoId,
        cpoDetailsSetter: (key: string, value: any) => {
            formSetter(cpoDetails, setCpoDetails, key, value)
        },
        getcpoDetailsValue: (key: any) => getValue(cpoDetails, key),
        removecpoDetailsKey: (key: any) => {
            removeKey(cpoDetails, setCpoDetails, key)
        },

        stationDetailsSetter: (key: any, value: any) => {
            formSetter(stationDetails, setStationDetails, key, value)
        },
        getstationDetailsValue: (key: any) => getValue(stationDetails, key),
        removestationDetailsKey: (key: any) => {
            removeKey(stationDetails, setStationDetails, key)
        },

        hostDetailsSetter: (key: any, value: any) => {
            formSetter(hostDetails, setHostDetails, key, value)
        },
        gethostDetailsValue: (key: any) => getValue(hostDetails, key),
        removehostDetailsKey: (key: any) => {
            removeKey(hostDetails, setHostDetails, key)
        },

        paymentDetailsSetter: (key: any, value: any) => {
            formSetter(paymentDetails, setPaymentDetails, key, value)
        },
        getPaymentDetailsValue: (key: any) => getValue(paymentDetails, key),
        removePaymentDetailsKey: (key: any) => {
            removeKey(paymentDetails, setPaymentDetails, key)
        },
        paymentTerms,
        addPaymentTerms,
        editPaymentTerm,
        removePaymentTerms,
        getPaymentTermsValue,
        getFormStepDetailLoading,

        spocDetailsSetter: (key: any, value: any) => {
            formSetter(spocDetails, setSpocDetails, key, value)
        },
        getSpocDetailsValue: (key: any) => getValue(spocDetails, key),
        removeSpocDetailsKey: (key: any) => {
            removeKey(spocDetails, setSpocDetails, key)
        },
        setSiteDetails,
        siteDetails,
        handleSameAsClientPoc,
        disableSave,
        basicDetails,
        setBasicDetails,
        validateLong,
        validateLat,
        handleChargerRowValidation,
        isChargerDetailsEditable,
        hideAddChargerButton,
        chargerMappingSetter,
        deleteChargerRow,
        addChargerMappingRow,
        getChargerMappingValue,
        charger_mapping,
        amenities,
        setAmenities,
        amenitiesState,
        buttonLoading,
        stationDetails,
        setStationDetails,
        showError,
        setShowError,
        isValidEmail,
        chargerMappingValidation,
        cpoDetails,
        ops_ticket_id,
        getStepsArray,
        freezeField,
        surveyTicketLinked,
        setSurveyTicketLinked,
        registrationCityList,
        hostingCityList,
    }
}

export default FormContextProvider
